import React, { useState, useEffect, useCallback, useMemo, memo } from "react";
import {
  Link,
  Redirect,
} from "react-router-dom";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import MdlSelectSession from "../dialog/MdlSelectSession";
import BackButton from "../ChildComponent/BackButton";
import { Modal } from "react-bootstrap";
import EventInvitation from "./EventInvitation";

const EventList = () => {
  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [isOpenEventModal, setIsOpenEventModal] = useState(false);
  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("token") !== null
  );
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [sessionName, setSessionName] = useState("");
  const [eventList, setEventList] = useState([]);
  
  // Event form state
  const [eventName, setEventName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [description, setDescription] = useState("");
  const [eventVenue, setEventVenue] = useState("");
  const [reportingTime, setReportingTime] = useState("");
  const [isPaid, setIsPaid] = useState("No");
  const [eventFee, setEventFee] = useState("0");
  const [selectedEventForInstruction, setSelectedEventForInstruction] = useState(null);
  const [isOpenInstructionModal, setIsOpenInstructionModal] = useState(false);
  const [eventInstructions, setEventInstructions] = useState([""]);
  const [editingInstructionId, setEditingInstructionId] = useState(null);
  const [editingInstructionText, setEditingInstructionText] = useState("");
  const [deletingEventId, setDeletingEventId] = useState(null);
  const [selectedEventForGroup, setSelectedEventForGroup] = useState(null);
  const [isOpenGroupModal, setIsOpenGroupModal] = useState(false);
  const [selectedEventForShare, setSelectedEventForShare] = useState(null);
  const [isOpenShareModal, setIsOpenShareModal] = useState(false);
  const [selectedEventForProgram, setSelectedEventForProgram] = useState(null);
  const [isOpenProgramModal, setIsOpenProgramModal] = useState(false);
  const [selectedEventForClass, setSelectedEventForClass] = useState(null);
  const [isOpenClassModal, setIsOpenClassModal] = useState(false);
  const [eventType, setEventType] = useState("CULTURAL");
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [mClassData, setMClassData] = useState([]);
  const [classBoard, setClassBoard] = useState([]);
  const [classMedium, setClassMedium] = useState([]);
  const [selectedBoardId, setSelectedBoardId] = useState("");
  const [selectedMediumId, setSelectedMediumId] = useState("");
  const [loadingClasses, setLoadingClasses] = useState(false);
  const [selectedEventForInvitation, setSelectedEventForInvitation] = useState(null);
  const [isOpenInvitationModal, setIsOpenInvitationModal] = useState(false);

  // Modern styles
  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.textContent = `
      .eventlist-modern .page-card {
        background: #fff;
        border-radius: 14px;
        box-shadow: 0 10px 24px rgba(0,0,0,0.08);
        border: 1px solid #eef1f4;
      }
      .eventlist-modern .session-banner {
        padding: 10px 12px;
        border-radius: 10px;
        background: linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#6366f1"} 100%);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        transition: all 0.2s ease;
      }
      .eventlist-modern .session-banner:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      }
      .eventlist-modern .list-container { 
        padding: 8px 2px; 
      }
      .eventlist-modern .row-card {
        background: #fff;
        border: 2px solid #e2e8f0;
        border-radius: 12px;
        padding: 16px 18px;
        margin-bottom: 14px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        transition: box-shadow .2s ease, transform .2s ease, border-color .2s ease;
      }
      .eventlist-modern .row-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(0,0,0,0.08);
        border-color: ${COLORS.primary_color_shade6 || "#3b82f6"};
      }
      .eventlist-modern .row-top {
        display: flex; 
        align-items: center; 
        gap: 12px; 
        justify-content: space-between;
        flex-wrap: wrap;
      }
      .eventlist-modern .left-meta { 
        display: flex; 
        align-items: center; 
        gap: 12px; 
        flex: 1;
        min-width: 200px;
      }
      .eventlist-modern .icon { 
        height: 48px; 
        width: 48px; 
        border-radius: 10px;
        background: linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade4 || "#60a5fa"} 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
      }
      .eventlist-modern .event-header {
        flex: 1;
      }
      .eventlist-modern .event-name {
        font-size: 18px;
        font-weight: 700;
        color: #111827;
        margin-bottom: 4px;
      }
      .eventlist-modern .event-id {
        font-size: 12px;
        color: #6b7280;
        font-weight: 600;
      }
      .eventlist-modern .event-details {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 12px;
        margin-top: 8px;
      }
      .eventlist-modern .detail-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        border: 1px solid #e2e8f0;
        border-radius: 8px;
      }
      .eventlist-modern .detail-icon {
        color: ${COLORS.primary_color_shade6 || "#3b82f6"};
        font-size: 14px;
        width: 20px;
        text-align: center;
      }
      .eventlist-modern .detail-label {
        font-size: 11px;
        color: #6b7280;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      .eventlist-modern .detail-value {
        font-size: 13px;
        color: #111827;
        font-weight: 600;
        margin-left: auto;
      }
      .eventlist-modern .description {
        margin-top: 8px;
        padding: 8px 12px;
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        display: flex;
        align-items: flex-start;
        gap: 8px;
      }
      .eventlist-modern .btns { 
        display: flex; 
        gap: 8px; 
        flex-wrap: wrap;
        margin-top: 8px;
      }
      .eventlist-modern .btn {
        padding: 8px 16px; 
        border-radius: 10px; 
        border: 2px solid; 
        font-weight: 600;
        font-size: 13px;
        background: transparent; 
        transition: all .15s ease; 
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 6px;
        text-decoration: none;
      }
      .eventlist-modern .btn.primary { 
        color: ${COLORS.primary_color_shade6 || "#0d6efd"}; 
        border-color: ${COLORS.primary_color_shade6 || "#0d6efd"}; 
      }
      .eventlist-modern .btn.primary:hover { 
        background: ${COLORS.primary_color_shade6 || "#0d6efd"}; 
        color: #fff; 
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
      }
      .eventlist-modern .btn.success { 
        color: #16a34a; 
        border-color: #16a34a; 
      }
      .eventlist-modern .btn.success:hover { 
        background: #16a34a; 
        color: #fff; 
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
      }
      .eventlist-modern .btn.info { 
        color: #17a2b8; 
        border-color: #17a2b8; 
      }
      .eventlist-modern .btn.info:hover {
        background: #17a2b8;
        color: #fff;
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
      }
      .eventlist-modern .btn.warning {
        color: #f59e0b;
        border-color: #f59e0b;
      }
      .eventlist-modern .btn.warning:hover {
        background: #f59e0b;
        color: #fff;
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(245, 158, 11, 0.3);
      }
      .eventlist-modern .btn.danger {
        color: #dc2626;
        border-color: #dc2626;
      }
      .eventlist-modern .btn.danger:hover {
        background: #dc2626;
        color: #fff;
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(220, 38, 38, 0.2);
      }
      .eventlist-modern .status-badge {
        font-size: 11px;
        font-weight: 700;
        padding: 4px 10px;
        border-radius: 999px;
        border: 1px solid transparent;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      .eventlist-modern .status-active { 
        background: #d1fae5; 
        color: #059669; 
        border-color: #86efac; 
      }
      .eventlist-modern .status-inactive { 
        background: #f5f5f5; 
        color: #555; 
        border-color: #e7e7e7; 
      }
      .eventlist-modern .empty-state {
        text-align: center;
        padding: 60px 20px;
        background: linear-gradient(135deg, #f9fafb 0%, #ffffff 100%);
        border-radius: 12px;
        border: 2px dashed #d1d5db;
      }
      .eventlist-modern .empty-icon {
        width: 80px;
        height: 80px;
        border-radius: 20px;
        background: linear-gradient(135deg, ${COLORS.primary_color_shade1 || "#dbeafe"} 0%, ${COLORS.primary_color_shade2 || "#bfdbfe"} 100%);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        font-size: 40px;
        color: ${COLORS.primary_color_shade6 || "#3b82f6"};
        opacity: 0.6;
      }
      .eventlist-modern .instructions-section {
        margin-top: 16px;
        padding: 16px 20px;
        background: linear-gradient(135deg, ${COLORS.primary_color_shade1 || "#dbeafe"} 0%, ${COLORS.primary_color_shade2 || "#bfdbfe"} 100%);
        border: 2px solid ${COLORS.primary_color_shade4 || "#93c5fd"};
        border-left: 5px solid ${COLORS.primary_color_shade6 || "#3b82f6"};
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
      }
      .eventlist-modern .instructions-title {
        font-size: 14px;
        font-weight: 700;
        color: ${COLORS.primary_color_shade8 || "#1e40af"};
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        gap: 8px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      .eventlist-modern .instructions-list {
        list-style: none;
        padding: 0;
        margin: 0;
      }
      .eventlist-modern .instruction-item {
        font-size: 13px;
        color: ${COLORS.black8 || "#1f2937"};
        padding: 10px 12px;
        padding-left: 32px;
        margin-bottom: 8px;
        position: relative;
        line-height: 1.6;
        background: rgba(255, 255, 255, 0.7);
        border-radius: 8px;
        border: 1px solid rgba(59, 130, 246, 0.2);
        transition: all 0.2s ease;
      }
      .eventlist-modern .instruction-item:hover {
        background: rgba(255, 255, 255, 0.9);
        border-color: ${COLORS.primary_color_shade4 || "#93c5fd"};
        box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
      }
      .eventlist-modern .instruction-item:before {
        content: "✓";
        position: absolute;
        left: 10px;
        top: 10px;
        color: ${COLORS.primary_color_shade6 || "#3b82f6"};
        font-weight: bold;
        font-size: 14px;
        background: rgba(59, 130, 246, 0.1);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .eventlist-modern .add-event-btn {
        background: linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#6366f1"} 100%);
        color: #fff;
        border: none;
        padding: 12px 24px;
        borderRadius: 10px;
        fontSize: 14px;
        fontWeight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
        gap: 8px;
        boxShadow: 0 4px 12px rgba(0,0,0,0.15);
      }
      .eventlist-modern .add-event-btn:hover {
        transform: translateY(-2px);
        boxShadow: 0 6px 16px rgba(0,0,0,0.2);
      }
      .event-creation-modal .modal-content {
        border-radius: 10px;
        overflow: hidden;
        border: none;
        box-shadow: 0 10px 40px rgba(0,0,0,0.2);
      }
      .event-creation-modal .modal-header {
        border-radius: 10px 10px 0 0;
        overflow: hidden;
      }
      .event-creation-modal .modal-footer {
        border-radius: 0 0 10px 10px;
        overflow: hidden;
      }
      .share-event-modal .modal-content {
        border-radius: 10px;
        overflow: hidden;
        border: none;
        box-shadow: 0 10px 40px rgba(0,0,0,0.2);
      }
      .share-event-modal .modal-header {
        border-radius: 0;
        overflow: hidden;
        margin: 0;
        padding: 20px 24px;
      }
      .share-event-modal .modal-body {
        border-radius: 0;
        padding: 24px;
      }
      .share-event-modal .modal-dialog {
        margin: 1.75rem auto;
      }
      .manage-program-modal .modal-content {
        border-radius: 10px;
        overflow: hidden;
        border: none;
        box-shadow: 0 10px 40px rgba(0,0,0,0.2);
      }
      .manage-program-modal .modal-header {
        border-radius: 10px 10px 0 0;
        overflow: hidden;
      }
      .manage-program-modal .modal-body {
        border-radius: 0 0 10px 10px;
      }
      .manage-class-modal .modal-content {
        border-radius: 10px;
        overflow: hidden;
        border: none;
        box-shadow: 0 10px 40px rgba(0,0,0,0.2);
      }
      .manage-class-modal .modal-header {
        border-radius: 10px 10px 0 0;
        overflow: hidden;
      }
      .manage-class-modal .modal-body {
        border-radius: 0 0 10px 10px;
      }
    `;
    document.head.appendChild(styleTag);
    return () => {
      if (styleTag && document.head.contains(styleTag)) {
        document.head.removeChild(styleTag);
      }
    };
  }, []);

  useEffect(() => {
    const mSession = SessionManager.getCurrentSession();
    if (mSession && mSession.length > 0) {
      setSessionId(mSession[0].session_id);
      setSessionName(mSession[0].session_name);
      window.scrollTo(0, 0);
      getEventList(mSession[0].session_id);
    }
  }, []);

  const getEventList = useCallback((session_id) => {
    if (!session_id) return;
    
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getEventList.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = { 
      school_code: SCHOOL_CODE, 
      session_id: session_id 
    };

    // Build full URL with parameters for logging
    const fullURL = URL + "?" + new URLSearchParams(params).toString();
    console.log("getEventList - Full URL:", fullURL);
    console.log("getEventList - Parameters:", params);
    console.log("getEventList - Session ID:", session_id);
    console.log("getEventList - School Code:", SCHOOL_CODE);

    axios
      .get(URL, {
        params: params,
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        console.log("getEventList - Response received:", response);
        if (response.api_status === "OK") {
          // Debug: Check instruction structure and log classes/programs
          if (response.data && response.data.length > 0) {
            console.log("getEventList - Total events fetched:", response.data.length);
            response.data.forEach((event, index) => {
              console.log(`Event ${index + 1} (${event.event_id}):`, {
                event_name: event.event_name,
                event_type: event.event_type,
                classes_count: event.event_classes ? event.event_classes.length : 0,
                programs_count: event.event_programs ? event.event_programs.length : 0,
                classes: event.event_classes || [],
                programs: event.event_programs || []
              });
            });
            
            const firstEvent = response.data[0];
            if (firstEvent.instructions && firstEvent.instructions.length > 0) {
              console.log("Sample instruction structure:", firstEvent.instructions[0]);
            }
          }
          setEventList(response.data || []);
        } else {
          console.error("getEventList - API Error:", response.api_remark || "Failed to load events");
          myToast.notify_warning(response.api_remark || "Failed to load events");
          setEventList([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("getEventList - Error fetching event list:", error);
        console.error("getEventList - Error response:", error.response);
        console.error("getEventList - Error URL:", fullURL);
        myToast.notify_error("Error loading events");
        setEventList([]);
      });
  }, []);

  const handleSessionDialogToggle = useCallback(() => {
    setIsOpenSessionDialog((prev) => !prev);
  }, []);

  const handleSelectedSession = useCallback((session_id, session_name) => {
    setSessionId(session_id);
    setSessionName(session_name);
    setIsOpenSessionDialog(false);
    getEventList(session_id);
  }, [getEventList]);

  const formatDate = useCallback((dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch (error) {
      return dateString;
    }
  }, []);

  // Created By Cursor — format DB time (HH:MM:SS or HH:MM) for display
  const formatTime = useCallback((timeString) => {
    if (!timeString) return "N/A";
    const raw = String(timeString).trim();
    const m = raw.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
    if (!m) return raw;
    let h = parseInt(m[1], 10);
    const min = m[2];
    if (Number.isNaN(h)) return raw;
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12;
    if (h === 0) h = 12;
    return `${h}:${min} ${ampm}`;
  }, []);

  const handleOpenEventModal = useCallback(() => {
    console.log("Opening event modal");
    setIsOpenEventModal(true);
    // Reset form
    setEventName("");
    setStartDate("");
    setEndDate("");
    setDescription("");
    setEventVenue("");
    setReportingTime("");
    setIsPaid("No");
    setEventFee("0");
    setEventType("CULTURAL");
    setSelectedClasses([]);
    // Load classes when modal opens
    if (sessionId) {
      getClass();
    }
  }, [sessionId]);

  const handleCloseEventModal = useCallback(() => {
    setIsOpenEventModal(false);
  }, []);


  const getClass = useCallback(() => {
    if (!sessionId) return;
    
    setLoadingClasses(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getClass.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          session_id: sessionId,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoadingClasses(false);
        if (response.api_status === "OK") {
          setMClassData(response.data.class || []);
          setClassBoard(response.data.board || []);
          setClassMedium(response.data.medium || []);
          
          // Auto-select first board and medium
          if (response.data.board && response.data.board.length > 0) {
            setSelectedBoardId(response.data.board[0].board_id);
          }
          if (response.data.medium && response.data.medium.length > 0) {
            setSelectedMediumId(response.data.medium[0].medium_id);
          }
        } else {
          myToast.notify_warning(response.api_remark || "Failed to load classes");
        }
      })
      .catch((error) => {
        setLoadingClasses(false);
        console.error("Error fetching class data:", error);
        myToast.notify_error("Error loading classes");
      });
  }, [sessionId]);

  // Memoize filtered class list to avoid recalculating on every render
  const mFilteredClassSectionList = useMemo(() => {
    if (!selectedBoardId || !selectedMediumId || mClassData.length === 0) {
      return [];
    }

    const mFilteredClassList = mClassData.filter(
      (item) => item.board_id === selectedBoardId && item.medium_id === selectedMediumId
    );
    
    const filteredSectionList = [];
    
    // Process classes and sections
    for (let i = 0; i < mFilteredClassList.length; i++) {
      const item = mFilteredClassList[i];
      const SECTION = item.section;
      
      if (SECTION === "No" || !SECTION) {
        filteredSectionList.push({
          ...item,
          section_id: "No",
        });
      } else {
        // Handle sections array
        const tempSection = Array.isArray(SECTION) ? SECTION : [];
        for (let j = 0; j < tempSection.length; j++) {
          const sectionItem = tempSection[j];
          filteredSectionList.push({
            ...sectionItem,
            board_id: selectedBoardId,
            board_name: item.board_name,
            medium_id: selectedMediumId,
            medium_name: item.medium_name,
            class_id: item.class_id,
            class_name: item.class_name,
          });
        }
      }
    }
    
    return filteredSectionList;
  }, [selectedBoardId, selectedMediumId, mClassData]);

  // Memoize class selection helpers
  const getClassKey = useCallback((classItem) => {
    return `${classItem.class_id}_${classItem.section_id || "No"}`;
  }, []);

  const handleClassToggle = useCallback((classItem) => {
    const classKey = getClassKey(classItem);
    setSelectedClasses((prev) => {
      const isSelected = prev.some((c) => getClassKey(c) === classKey);
      if (isSelected) {
        return prev.filter((c) => getClassKey(c) !== classKey);
      } else {
        return [...prev, classItem];
      }
    });
  }, [getClassKey]);

  const isClassSelected = useCallback((classItem) => {
    const classKey = getClassKey(classItem);
    return selectedClasses.some((c) => getClassKey(c) === classKey);
  }, [selectedClasses, getClassKey]);

  const handleCreateEvent = useCallback(() => {
    if (!eventName.trim()) {
      myToast.notify_warning("Please enter event name");
      return;
    }
    if (!startDate) {
      myToast.notify_warning("Please select start date");
      return;
    }
    if (!endDate) {
      myToast.notify_warning("Please select end date");
      return;
    }
    if (!description.trim()) {
      myToast.notify_warning("Please enter description");
      return;
    }
    if (!eventVenue.trim()) {
      myToast.notify_warning("Please enter event venue");
      return;
    }
    if (!eventType) {
      myToast.notify_warning("Please select event type");
      return;
    }
    if (selectedClasses.length === 0) {
      myToast.notify_warning("Please select at least one class");
      return;
    }
    if (isPaid === "Yes" && (!eventFee || parseFloat(eventFee) <= 0)) {
      myToast.notify_warning("Please enter valid event fee");
      return;
    }

    setSaving(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const STAFF_ID = SessionManager.getStaffDetails()?.staff_id || "";
    const FUNCTION_NAME = "AddNewEvent.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    // Prepare class list for API - send class_id and class_name
    const classListForAPI = selectedClasses.map((classItem) => ({
      class_id: classItem.class_id,
      class_name: classItem.class_name || classItem.class_id
    }));

    const params = {
      staff_id: STAFF_ID,
      session_id: sessionId,
      event_name: eventName.trim(),
      start_date: startDate,
      end_date: endDate,
      description: description.trim(),
      event_venue: eventVenue.trim(),
      // Created By Cursor — DB column is `repoting_time`
      repoting_time: reportingTime || "",
      event_type: eventType,
      is_paid: isPaid,
      event_fee: isPaid === "Yes" ? eventFee : "0",
      class_list: JSON.stringify(classListForAPI),
      school_code: SCHOOL_CODE,
    };

    // Log the URL with parameters
    const urlWithParams = URL + "?" + new URLSearchParams(params).toString();
    console.log("Add Event URL:", urlWithParams);
    console.log("Add Event Params:", params);

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setSaving(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Event created successfully with participating classes");
          handleCloseEventModal();
          getEventList(sessionId);
        } else {
          myToast.notify_warning(response.api_remark || "Failed to create event");
        }
      })
      .catch((error) => {
        setSaving(false);
        console.error("Error creating event:", error);
        myToast.notify_error("Error creating event");
      });
  }, [eventName, startDate, endDate, description, eventVenue, reportingTime, eventType, selectedClasses, isPaid, eventFee, sessionId, handleCloseEventModal, getEventList]);

  const handleUpdateInstruction = (instructionId, instructionText, eventId) => {
    if (!instructionText.trim()) {
      myToast.notify_warning("Instruction cannot be empty");
      return;
    }

    if (!instructionId) {
      myToast.notify_warning("Invalid instruction ID");
      console.error("Update instruction: instructionId is missing", instructionId);
      return;
    }

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "UpdateEventInstruction.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      instruction_id: instructionId,
      instruction: instructionText.trim(),
      school_code: SCHOOL_CODE,
    };

    console.log("Updating instruction with params:", params);

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        console.log("Update instruction response:", response);
        if (response.api_status === "OK") {
          myToast.notify_success("Instruction updated successfully");
          setEditingInstructionId(null);
          setEditingInstructionText("");
          getEventList(sessionId);
        } else {
          myToast.notify_warning(response.api_remark || "Failed to update instruction");
        }
      })
      .catch((error) => {
        console.error("Error updating instruction:", error);
        console.error("Error response:", error.response);
        const errorMessage = error.response?.data?.api_remark || error.message || "Error updating instruction";
        myToast.notify_error(errorMessage);
      });
  };

  const handleDeleteInstruction = (instructionId, eventId) => {
    if (!window.confirm("Are you sure you want to delete this instruction?")) {
      return;
    }

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "DeleteEventInstruction.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      instruction_id: instructionId,
      school_code: SCHOOL_CODE,
    };

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK") {
          myToast.notify_success("Instruction deleted successfully");
          getEventList(sessionId);
        } else {
          myToast.notify_warning(response.api_remark || "Failed to delete instruction");
        }
      })
      .catch((error) => {
        console.error("Error deleting instruction:", error);
        myToast.notify_error("Error deleting instruction");
      });
  };

  const handleDeleteEvent = (eventId, eventName) => {
    if (!window.confirm(`Are you sure you want to delete the event "${eventName}"? This will permanently delete the event, all participants, instructions, and related data. This action cannot be undone.`)) {
      return;
    }

    setDeletingEventId(eventId);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const STAFF_ID = SessionManager.getStaffDetails()?.staff_id || "";
    const FUNCTION_NAME = "DeleteEvent.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    const params = {
      event_id: eventId,
      staff_id: STAFF_ID,
      session_id: sessionId,
      school_code: SCHOOL_CODE,
    };

    // Log the URL with parameters
    const urlWithParams = URL + "?" + new URLSearchParams(params).toString();
    console.log("Delete Event URL:", urlWithParams);
    console.log("Delete Event Params:", params);

    axios
      .get(URL, { params })
      .then((res) => res.data)
      .then((response) => {
        setDeletingEventId(null);
        if (response.api_status === "OK") {
          myToast.notify_success("Event deleted successfully");
          getEventList(sessionId);
        } else {
          myToast.notify_warning(response.api_remark || "Failed to delete event");
        }
      })
      .catch((error) => {
        setDeletingEventId(null);
        console.error("Error deleting event:", error);
        myToast.notify_error("Error deleting event");
      });
  };

  const handleOpenInstructionModal = (event) => {
    setSelectedEventForInstruction(event);
    // Load existing instructions or start with empty
    if (event.instructions && Array.isArray(event.instructions) && event.instructions.length > 0) {
      setEventInstructions(event.instructions.map(inst => inst.instruction || ""));
    } else {
      setEventInstructions([""]);
    }
    setIsOpenInstructionModal(true);
  };

  const handleCloseInstructionModal = () => {
    setIsOpenInstructionModal(false);
    setSelectedEventForInstruction(null);
    setEventInstructions([""]);
  };

  const handleOpenInvitationModal = (event) => {
    setSelectedEventForInvitation(event);
    setIsOpenInvitationModal(true);
  };

  const handleCloseInvitationModal = () => {
    setIsOpenInvitationModal(false);
    setSelectedEventForInvitation(null);
  };

  const handleOpenGroupModal = (event) => {
    setSelectedEventForGroup(event);
    setIsOpenGroupModal(true);
  };

  const getShareableLink = useCallback((event_id) => {
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    
    // Construct the shareable link URL using environment variables
    const shareableUrl = 
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      `Printables/Event/event_participant.php?&event_id=${event_id}&school_code=${SCHOOL_CODE}`;
    
    return shareableUrl;
  }, []);

  const handleOpenShareModal = useCallback((event) => {
    setSelectedEventForShare(event);
    setIsOpenShareModal(true);
  }, []);

  const handleCloseShareModal = useCallback(() => {
    setIsOpenShareModal(false);
    setSelectedEventForShare(null);
  }, []);

  const handleCopyShareableLink = useCallback((event_id) => {
    const shareableUrl = getShareableLink(event_id);
    
    // Copy to clipboard
    navigator.clipboard.writeText(shareableUrl)
      .then(() => {
        myToast.notify_success("Shareable link copied to clipboard!");
        console.log("Shareable link:", shareableUrl);
      })
      .catch((err) => {
        console.error("Failed to copy link:", err);
        myToast.notify_error("Failed to copy link. Please try again.");
      });
  }, [getShareableLink]);

  const handleShareOnWhatsApp = useCallback((event_id, event_name) => {
    const shareableUrl = getShareableLink(event_id);
    const message = encodeURIComponent(`Check out this event: ${event_name}\n\n${shareableUrl}`);
    const whatsappUrl = `https://wa.me/?text=${message}`;
    
    window.open(whatsappUrl, '_blank');
  }, [getShareableLink]);

  const handleCloseGroupModal = () => {
    setIsOpenGroupModal(false);
    setSelectedEventForGroup(null);
  };

  const handleOpenProgramModal = useCallback((event) => {
    setSelectedEventForProgram(event);
    setIsOpenProgramModal(true);
  }, []);

  const handleCloseProgramModal = useCallback(() => {
    setIsOpenProgramModal(false);
    setSelectedEventForProgram(null);
  }, []);

  const handleOpenClassModal = useCallback((event) => {
    setSelectedEventForClass(event);
    setIsOpenClassModal(true);
  }, []);

  const handleCloseClassModal = useCallback(() => {
    setIsOpenClassModal(false);
    setSelectedEventForClass(null);
  }, []);

  const handleAddEventInstruction = () => {
    setEventInstructions([...eventInstructions, ""]);
  };

  const handleRemoveEventInstruction = (index) => {
    const newInstructions = eventInstructions.filter((_, i) => i !== index);
    setEventInstructions(newInstructions.length > 0 ? newInstructions : [""]);
  };

  const handleEventInstructionChange = (index, value) => {
    const newInstructions = [...eventInstructions];
    newInstructions[index] = value;
    setEventInstructions(newInstructions);
  };

  const handleSaveInstructions = () => {
    if (!selectedEventForInstruction) return;
    
    const validInstructions = eventInstructions.filter(inst => inst.trim() !== "");
    if (validInstructions.length === 0) {
      myToast.notify_warning("Please add at least one instruction");
      return;
    }

    setSaving(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "AddEventInstruction.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    // Save all instructions
    const savePromises = validInstructions.map((instruction) => {
      const params = {
        event_id: selectedEventForInstruction.event_id,
        session_id: sessionId,
        instruction: instruction.trim(),
        school_code: SCHOOL_CODE,
      };
      return axios.get(URL, { params });
    });

    Promise.all(savePromises)
      .then((responses) => {
        setSaving(false);
        console.log("Save responses:", responses);
        const allSuccess = responses.every((res) => res.data && res.data.api_status === "OK");
        if (allSuccess) {
          myToast.notify_success("Instructions added successfully");
          handleCloseInstructionModal();
          getEventList(sessionId);
        } else {
          const failedResponses = responses.filter((res) => !res.data || res.data.api_status !== "OK");
          console.error("Failed responses:", failedResponses);
          const errorMessage = failedResponses[0]?.data?.api_remark || "Some instructions could not be saved";
          myToast.notify_warning(errorMessage);
        }
      })
      .catch((error) => {
        setSaving(false);
        console.error("Error saving instructions:", error);
        console.error("Error response:", error.response);
        const errorMessage = error.response?.data?.api_remark || error.message || "Error saving instructions";
        myToast.notify_error(errorMessage);
      });
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <div className="content eventlist-modern">
      <div className="content-header">
        <div
          className="leftside-content-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <ul className="breadcrumbs">
            <li>
              <i className="fa fa-home" aria-hidden="true" />
              <a href="#">Event List</a>
            </li>
          </ul>
          <BackButton />
        </div>
      </div>

      <div
        className="animated fadeInUp page-card box_shadow"
        style={{ margin: "10px 80px 10px 80px", padding: "20px" }}
      >
        {loading && <MyLoader />}

        <div className="row" style={{ marginBottom: "16px" }}>
          <Link
            to="#"
            onClick={(e) => {
              e.preventDefault();
              handleSessionDialogToggle();
            }}
            style={{ width: "100%", textDecoration: "none" }}
          >
            <div className="session-banner">
              <p style={{ margin: 0, fontSize: "18px", fontWeight: "600" }}>
                Session: {sessionName}
              </p>
              <i className="fa fa-calendar" style={{ fontSize: "20px" }} />
            </div>
          </Link>
        </div>

        <div className="EventList mar_top1">
          <div
            className="EventList__container list-container"
            style={{ margin: "10px 10px 10px 10px" }}
          >
            {!loading && eventList.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">
                  <i className="fa fa-calendar-times" />
                </div>
                <p
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    marginBottom: "10px",
                    color: "#374151",
                  }}
                >
                  No Events Available
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#6b7280",
                    maxWidth: "400px",
                    margin: "0 auto",
                  }}
                >
                  No events have been created for this session yet.
                </p>
              </div>
            ) : (
              eventList.map((item, index) => (
                <div className="row-card" key={item.event_id || index}>
                  <div className="row-top">
                    <div className="left-meta">
                      <div className="icon">
                        <i className="fa fa-calendar-check" />
                      </div>
                      <div className="event-header">
                        <div className="event-name">{item.event_name}</div>
                        <div className="event-id">
                          Event ID: {item.event_id}
                          {item.status && (
                            <span
                              className={`status-badge ${
                                item.status === "Active"
                                  ? "status-active"
                                  : "status-inactive"
                              }`}
                              style={{ marginLeft: "10px" }}
                            >
                              {item.status}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                      <button
                        type="button"
                        onClick={() => handleOpenShareModal(item)}
                        className="btn"
                        style={{
                          background: COLORS.primary_color_shade6 || "#3b82f6",
                          color: "#fff",
                          border: "none",
                          padding: "8px 16px",
                          borderRadius: "8px",
                          fontSize: "13px",
                          fontWeight: 600,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = COLORS.primary_color_shade7 || "#4f46e5";
                          e.currentTarget.style.transform = "translateY(-1px)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = COLORS.primary_color_shade6 || "#3b82f6";
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                        title="Share Event"
                      >
                        <i className="fa fa-share-alt" />
                        Share
                      </button>
                    </div>
                  </div>

                  <div className="event-details">
                    <div className="detail-item">
                      <i className="fa fa-calendar-alt detail-icon" />
                      <div>
                        <div className="detail-label">Start Date</div>
                        <div className="detail-value">
                          {formatDate(item.start_date)}
                        </div>
                      </div>
                    </div>
                    <div className="detail-item">
                      <i className="fa fa-calendar-check detail-icon" />
                      <div>
                        <div className="detail-label">End Date</div>
                        <div className="detail-value">
                          {formatDate(item.end_date)}
                        </div>
                      </div>
                    </div>
                    <div className="detail-item">
                      <i className="fa fa-clock detail-icon" />
                      <div>
                        <div className="detail-label">Reporting Time</div>
                        <div className="detail-value">
                          {formatTime(item.repoting_time || item.reporting_time)}
                        </div>
                      </div>
                    </div>
                    <div className="detail-item">
                      <i className="fa fa-map-marker-alt detail-icon" />
                      <div>
                        <div className="detail-label">Venue</div>
                        <div className="detail-value">
                          {item.event_venue || "N/A"}
                        </div>
                      </div>
                    </div>
                    <div className="detail-item">
                      <i className="fa fa-users detail-icon" />
                      <div>
                        <div className="detail-label">Participants</div>
                        <div className="detail-value">
                          {item.participant_count || 0}
                        </div>
                      </div>
                    </div>
                    {item.event_type && (
                      <div className="detail-item">
                        <i className="fa fa-tag detail-icon" />
                        <div>
                          <div className="detail-label">Event Type</div>
                          <div className="detail-value">
                            {item.event_type}
                          </div>
                        </div>
                      </div>
                    )}
                    {item.is_paid === "1" && (
                      <div className="detail-item">
                        <i className="fa fa-rupee-sign detail-icon" />
                        <div>
                          <div className="detail-label">Event Fee</div>
                          <div className="detail-value">
                            ₹{item.event_fee || "0"}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {item.description && (
                    <div className="description">
                      <i className="fa fa-align-left detail-icon" style={{ marginTop: "2px" }} />
                      <div>
                        <div className="detail-label">Description</div>
                        <div className="detail-value">
                          {item.description}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="instructions-section">
                    <div className="instructions-title">
                      <i className="fa fa-info-circle" />
                      Instructions
                    </div>
                    {item.instructions && Array.isArray(item.instructions) && item.instructions.length > 0 ? (
                      <ul className="instructions-list">
                        {item.instructions.map((instruction, idx) => {
                          // Try multiple possible ID field names
                          const instructionId = instruction.id || instruction.ID || instruction.instruction_id || instruction.instructionId;
                          // Debug: Log instruction object to see its structure
                          if (!instructionId && idx === 0) {
                            console.log("Instruction object structure:", instruction);
                            console.log("All instructions for event:", item.instructions);
                            console.log("Available keys:", Object.keys(instruction));
                          }
                          return (
                          <li key={instructionId || `inst-${idx}`} className="instruction-item" style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "space-between" }}>
                            {editingInstructionId && instructionId && String(editingInstructionId) === String(instructionId) ? (
                              <div style={{ display: "flex", gap: "8px", flex: 1, alignItems: "center" }}>
                                <input
                                  type="text"
                                  value={editingInstructionText}
                                  onChange={(e) => setEditingInstructionText(e.target.value)}
                                  maxLength={150}
                                  style={{
                                    flex: 1,
                                    padding: "6px 10px",
                                    fontSize: "13px",
                                    border: `2px solid ${COLORS.primary_color_shade6 || "#3b82f6"}`,
                                    borderRadius: "6px",
                                    outline: "none",
                                  }}
                                  onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                      const instructionId = instruction.id || instruction.ID || instruction.instruction_id || instruction.instructionId;
                                      if (instructionId) {
                                        handleUpdateInstruction(instructionId, editingInstructionText, item.event_id);
                                      } else {
                                        myToast.notify_warning("Invalid instruction ID");
                                      }
                                    }
                                  }}
                                />
                                <button
                                  type="button"
                                  onClick={() => {
                                    const instructionId = instruction.id || instruction.ID || instruction.instruction_id || instruction.instructionId;
                                    if (instructionId) {
                                      handleUpdateInstruction(instructionId, editingInstructionText, item.event_id);
                                    } else {
                                      myToast.notify_warning("Invalid instruction ID");
                                    }
                                  }}
                                  style={{
                                    padding: "6px 12px",
                                    background: COLORS.primary_color_shade6 || "#3b82f6",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                  }}
                                >
                                  <i className="fa fa-check" />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    setEditingInstructionId(null);
                                    setEditingInstructionText("");
                                  }}
                                  style={{
                                    padding: "6px 12px",
                                    background: COLORS.grey5 || "#9E9E9E",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                  }}
                                >
                                  <i className="fa fa-times" />
                                </button>
                              </div>
                            ) : (
                              <>
                                <span style={{ flex: 1 }}>{instruction.instruction}</span>
                                <div style={{ display: "flex", gap: "4px" }}>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      // Try multiple possible ID field names
                                      const instructionId = instruction.id || instruction.ID || instruction.instruction_id || instruction.instructionId;
                                      if (instructionId) {
                                        setEditingInstructionId(String(instructionId));
                                        setEditingInstructionText(instruction.instruction || "");
                                      } else {
                                        console.error("Instruction ID is missing. Full instruction object:", instruction);
                                        console.error("Available keys:", Object.keys(instruction));
                                        myToast.notify_warning("Cannot edit: Instruction ID is missing");
                                      }
                                    }}
                                    style={{
                                      padding: "4px 8px",
                                      background: COLORS.primary_color_shade6 || "#3b82f6",
                                      color: "#fff",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                      fontSize: "11px",
                                    }}
                                    title="Edit"
                                  >
                                    <i className="fa fa-edit" />
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      const instructionId = instruction.id || instruction.ID || instruction.instruction_id || instruction.instructionId;
                                      if (instructionId) {
                                        handleDeleteInstruction(instructionId, item.event_id);
                                      } else {
                                        myToast.notify_warning("Invalid instruction ID");
                                      }
                                    }}
                                    style={{
                                      padding: "4px 8px",
                                      background: COLORS.red5 || "#f44336",
                                      color: "#fff",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                      fontSize: "11px",
                                    }}
                                    title="Delete"
                                  >
                                    <i className="fa fa-trash" />
                                  </button>
                                </div>
                              </>
                            )}
                          </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <div style={{ 
                        fontSize: "13px", 
                        color: COLORS.primary_color_shade8 || "#1e40af", 
                        padding: "16px 20px",
                        background: "rgba(255, 255, 255, 0.6)",
                        border: `2px dashed ${COLORS.primary_color_shade4 || "#93c5fd"}`,
                        borderRadius: "10px",
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        fontWeight: 500
                      }}>
                        <i className="fa fa-info-circle" style={{ fontSize: "16px", color: COLORS.primary_color_shade6 || "#3b82f6" }} />
                        <span>No instructions available. Click "Manage Instructions" to add.</span>
                      </div>
                    )}
                  </div>

                  {/* Event Classes Section */}
                  <div className="instructions-section" style={{ background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)", borderColor: COLORS.primary_color_shade4 || "#86efac", borderLeftColor: "#16a34a" }}>
                    <div className="instructions-title" style={{ color: "#15803d", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span>
                        <i className="fa fa-users" />
                        Participating Classes {item.event_classes && Array.isArray(item.event_classes) && item.event_classes.length > 0 ? `(${item.event_classes.length})` : ""}
                      </span>
                      <button
                        type="button"
                        onClick={() => handleOpenClassModal(item)}
                        style={{
                          background: "#16a34a",
                          color: "#fff",
                          border: "none",
                          padding: "6px 12px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: 600,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#15803d";
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "#16a34a";
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        <i className="fa fa-cog" />
                        Manage Class
                      </button>
                    </div>
                    {item.event_classes && Array.isArray(item.event_classes) && item.event_classes.length > 0 ? (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
                        {item.event_classes.map((classItem, idx) => {
                          // Debug log to see class data structure
                          if (idx === 0) {
                            console.log("Class Item Structure:", classItem);
                            console.log("Class Name:", classItem.class_name);
                            console.log("Class ID:", classItem.class_id);
                          }
                          
                          // Get class name - try multiple possible field names
                          const className = classItem.class_name || 
                                           classItem.name || 
                                           classItem.className || 
                                           classItem.class_name || 
                                           `Class ${classItem.class_id || idx + 1}`;
                          
                          return (
                            <span
                              key={idx}
                              style={{
                                padding: "8px 14px",
                                background: "#fff",
                                color: "#15803d",
                                borderRadius: "6px",
                                fontSize: "13px",
                                fontWeight: 600,
                                border: `1px solid ${COLORS.primary_color_shade4 || "#86efac"}`,
                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                              title={`Class ID: ${classItem.class_id || "N/A"}`}
                            >
                              <i className="fa fa-graduation-cap" style={{ fontSize: "11px" }} />
                              {className}
                            </span>
                          );
                        })}
                      </div>
                    ) : (
                      <div style={{ 
                        fontSize: "13px", 
                        color: "#15803d", 
                        padding: "12px",
                        background: "rgba(255, 255, 255, 0.6)",
                        border: `2px dashed #86efac`,
                        borderRadius: "8px",
                        textAlign: "center",
                        marginTop: "8px"
                      }}>
                        <i className="fa fa-info-circle" style={{ marginRight: "6px" }} />
                        No participating classes assigned
                      </div>
                    )}
                  </div>

                  {/* Share Event Section */}
                  <div className="instructions-section" style={{ background: "linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)", borderColor: COLORS.primary_color_shade4 || "#818cf8", borderLeftColor: COLORS.primary_color_shade6 || "#3b82f6" }}>
                    <div className="instructions-title" style={{ color: COLORS.primary_color_shade8 || "#1e40af", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span>
                        <i className="fa fa-share-alt" />
                        Share Event
                      </span>
                      <button
                        type="button"
                        onClick={() => handleOpenShareModal(item)}
                        style={{
                          background: COLORS.primary_color_shade6 || "#3b82f6",
                          color: "#fff",
                          border: "none",
                          padding: "6px 12px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: 600,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = COLORS.primary_color_shade7 || "#4f46e5";
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = COLORS.primary_color_shade6 || "#3b82f6";
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        <i className="fa fa-share-alt" />
                        Share
                      </button>
                    </div>
                    <div style={{ marginTop: "12px", display: "flex", gap: "10px", flexWrap: "wrap" }}>
                      <button
                        type="button"
                        onClick={() => handleCopyShareableLink(item.event_id)}
                        style={{
                          padding: "10px 16px",
                          background: "#fff",
                          color: COLORS.primary_color_shade8 || "#1e40af",
                          border: `2px solid ${COLORS.primary_color_shade4 || "#818cf8"}`,
                          borderRadius: "8px",
                          fontSize: "13px",
                          fontWeight: 600,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          transition: "all 0.2s ease",
                          flex: "1",
                          minWidth: "150px",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = COLORS.primary_color_shade1 || "#eff6ff";
                          e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#3b82f6";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "#fff";
                          e.currentTarget.style.borderColor = COLORS.primary_color_shade4 || "#818cf8";
                        }}
                      >
                        <i className="fa fa-copy" />
                        Copy Link
                      </button>
                      <button
                        type="button"
                        onClick={() => handleShareOnWhatsApp(item.event_id, item.event_name)}
                        style={{
                          padding: "10px 16px",
                          background: "#25D366",
                          color: "#fff",
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "13px",
                          fontWeight: 600,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          transition: "all 0.2s ease",
                          flex: "1",
                          minWidth: "150px",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#20BA5A";
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(37, 211, 102, 0.3)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "#25D366";
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <i className="fa fa-whatsapp" />
                        Share on WhatsApp
                      </button>
                    </div>
                    <div style={{ marginTop: "12px", padding: "10px", background: "rgba(255, 255, 255, 0.6)", borderRadius: "6px", fontSize: "12px", color: COLORS.primary_color_shade8 || "#1e40af" }}>
                      <i className="fa fa-info-circle" style={{ marginRight: "6px" }} />
                      Share this event link with participants to view event details
                    </div>
                  </div>

                  {/* Event Programs Section */}
                  <div className="instructions-section" style={{ background: "linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)", borderColor: "#fbbf24", borderLeftColor: "#f59e0b" }}>
                    <div className="instructions-title" style={{ color: "#92400e", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span>
                        <i className="fa fa-calendar-alt" />
                        Event Programs {item.event_programs && Array.isArray(item.event_programs) && item.event_programs.length > 0 ? `(${item.event_programs.length})` : ""}
                      </span>
                      <button
                        type="button"
                        onClick={() => handleOpenProgramModal(item)}
                        style={{
                          background: "#f59e0b",
                          color: "#fff",
                          border: "none",
                          padding: "6px 12px",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: 600,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "#d97706";
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "#f59e0b";
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        <i className="fa fa-cog" />
                        Manage Program
                      </button>
                    </div>
                    {item.event_programs && Array.isArray(item.event_programs) && item.event_programs.length > 0 ? (
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "8px" }}>
                        {item.event_programs.map((program, idx) => (
                          <div
                            key={idx}
                            style={{
                              padding: "10px 12px",
                              background: "rgba(255, 255, 255, 0.8)",
                              borderRadius: "8px",
                              border: `1px solid #fbbf24`,
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                              flexWrap: "wrap",
                            }}
                          >
                            <div style={{ flex: 1, minWidth: "200px" }}>
                              <div style={{ fontSize: "13px", fontWeight: 700, color: "#92400e", marginBottom: "4px" }}>
                                {program.program_name || "Program"}
                              </div>
                              {program.class_id && (
                                <div style={{ fontSize: "11px", color: "#78350f", marginTop: "2px" }}>
                                  Class: {program.class_id}
                                </div>
                              )}
                            </div>
                            {(program.program_date || program.program_time) && (
                              <div style={{ display: "flex", gap: "12px", fontSize: "12px", color: "#78350f" }}>
                                {program.program_date && (
                                  <span>
                                    <i className="fa fa-calendar" style={{ marginRight: "4px" }} />
                                    {formatDate(program.program_date)}
                                  </span>
                                )}
                                {program.program_time && (
                                  <span>
                                    <i className="fa fa-clock" style={{ marginRight: "4px" }} />
                                    {program.program_time}
                                  </span>
                                )}
                                {program.shift && (
                                  <span>
                                    <i className="fa fa-sun" style={{ marginRight: "4px" }} />
                                    {program.shift}
                                  </span>
                                )}
                              </div>
                            )}
                            {/* Mark/Rank Button based on event type */}
                            <div style={{ marginLeft: "auto" }}>
                              {item.event_type && item.event_type.toLowerCase() === "cultural" ? (
                                <Link
                                  to={`/AdminMain/EventProgramMark/${item.event_id}/${program.program_id}/${sessionId}`}
                                  style={{
                                    padding: "6px 12px",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: "#fff",
                                    background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    textDecoration: "none",
                                    boxShadow: "0 2px 6px rgba(139, 92, 246, 0.3)",
                                    transition: "all 0.2s ease",
                                  }}
                                >
                                  <i className="fa fa-trophy" />
                                  Add Mark & Rank
                                </Link>
                              ) : item.event_type && item.event_type.toLowerCase() === "competitive" ? (
                                <Link
                                  to={`/AdminMain/EventSubjectMark/${item.event_id}/${program.program_id}/${sessionId}`}
                                  style={{
                                    padding: "6px 12px",
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: "#fff",
                                    background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    textDecoration: "none",
                                    boxShadow: "0 2px 6px rgba(16, 185, 129, 0.3)",
                                    transition: "all 0.2s ease",
                                  }}
                                >
                                  <i className="fa fa-list-ol" />
                                  Manage Subject Mark
                                </Link>
                              ) : null}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div style={{ 
                        fontSize: "13px", 
                        color: "#92400e", 
                        padding: "12px",
                        background: "rgba(255, 255, 255, 0.6)",
                        border: `2px dashed #fbbf24`,
                        borderRadius: "8px",
                        textAlign: "center",
                        marginTop: "8px"
                      }}>
                        <i className="fa fa-info-circle" style={{ marginRight: "6px" }} />
                        No programs scheduled
                      </div>
                    )}
                  </div>

                  <div className="btns">
                    <Link
                      to={`/AdminMain/ManageEventParticipant/${item.event_id}/${sessionId}`}
                      className="btn primary"
                    >
                      <i className="fa fa-users" />
                      Manage Participant
                    </Link>
                    <Link
                      to={`/AdminMain/EventInvitation/${item.event_id}`}
                      className="btn success"
                    >
                      <i className="fa fa-envelope" />
                      Invitation
                    </Link>
                    <Link
                      to={`/AdminMain/EventCertificate/${item.event_id}`}
                      className="btn success"
                    >
                      <i className="fa fa-certificate" />
                      Certificate
                    </Link>
                    <Link
                      to={`/AdminMain/PrintableDocsEvent/event_participant/`}
                      className="btn success"
                    >
                      <i className="fa fa-id-card" />
                      Event Pass
                    </Link>
                    <button
                      type="button"
                      onClick={() => handleOpenInstructionModal(item)}
                      className="btn info"
                    >
                      <i className="fa fa-info-circle" />
                      Manage Instructions
                    </button>
                    <button
                      type="button"
                      onClick={() => handleOpenGroupModal(item)}
                      className="btn warning"
                    >
                      <i className="fa fa-layer-group" />
                      Manage Group
                    </button>
                    <button
                      type="button"
                      onClick={() => handleDeleteEvent(item.event_id, item.event_name)}
                      className="btn danger"
                      disabled={deletingEventId === item.event_id}
                      style={{
                        opacity: deletingEventId === item.event_id ? 0.6 : 1,
                        cursor: deletingEventId === item.event_id ? "not-allowed" : "pointer",
                      }}
                    >
                      {deletingEventId === item.event_id ? (
                        <>
                          <i className="fa fa-spinner fa-spin" />
                          Deleting...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-trash" />
                          Delete Event
                        </>
                      )}
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
          
          {/* Add Event Button at Bottom */}
          <div style={{ display: "flex", justifyContent: "center", marginTop: "24px", paddingTop: "20px", borderTop: `2px solid ${COLORS.grey3 || "#E0E0E0"}` }}>
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleOpenEventModal();
              }}
              style={{
                background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#6366f1"} 100%)`,
                color: "#fff",
                border: "none",
                padding: "12px 32px",
                borderRadius: "10px",
                fontSize: "15px",
                fontWeight: 600,
                cursor: "pointer",
                transition: "all 0.2s ease",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
              }}
            >
              <i className="fa fa-plus-circle" style={{ fontSize: "16px" }} />
              Add New Event
            </button>
          </div>
        </div>
      </div>

      {isOpenSessionDialog && (
        <MdlSelectSession
          isOpen={isOpenSessionDialog}
          onClose={handleSessionDialogToggle}
          onSelect={handleSelectedSession}
        />
      )}

      {/* Create Event Modal */}
      <Modal
        show={isOpenEventModal}
        onHide={handleCloseEventModal}
        size="lg"
        centered
        animation={false}
        backdrop={true}
        keyboard={true}
        dialogClassName="event-creation-modal"
      >
        <Modal.Header
          closeButton={false}
          style={{
            background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#6366f1"} 100%)`,
            color: "#fff",
            borderBottom: "none",
            borderRadius: "10px 10px 0 0",
            overflow: "hidden",
          }}
        >
          <Modal.Title style={{ color: "#fff", fontWeight: 700 }}>
            <i className="fa fa-calendar-plus" style={{ marginRight: "8px" }} />
            Create New Event
          </Modal.Title>
          <button
            type="button"
            className="close"
            onClick={handleCloseEventModal}
            style={{ color: "#fff", opacity: 1 }}
          >
            <span>&times;</span>
          </button>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {/* Event Name */}
            <div>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                <i className="fa fa-tag" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                Event Name <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
              </label>
              <input
                type="text"
                value={eventName}
                onChange={(e) => setEventName(e.target.value)}
                placeholder="Enter event name"
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  fontSize: "14px",
                  border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                  borderRadius: "8px",
                  transition: "all 0.3s ease",
                  outline: "none",
                }}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Date Range */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                  <i className="fa fa-calendar-alt" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                  Start Date <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
                </label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    fontSize: "14px",
                    border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    outline: "none",
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                  <i className="fa fa-calendar-check" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                  End Date <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
                </label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  min={startDate}
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    fontSize: "14px",
                    border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    outline: "none",
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />
              </div>
            </div>

            {/* Created By Cursor — Reporting Time */}
            <div>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                <i className="fa fa-clock" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                Reporting Time
              </label>
              <input
                type="time"
                value={reportingTime}
                onChange={(e) => setReportingTime(e.target.value)}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  fontSize: "14px",
                  border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                  borderRadius: "8px",
                  transition: "all 0.3s ease",
                  outline: "none",
                }}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Description */}
            <div>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                <i className="fa fa-align-left" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                Description <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
              </label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter event description"
                rows={3}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  fontSize: "14px",
                  border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                  borderRadius: "8px",
                  transition: "all 0.3s ease",
                  outline: "none",
                  resize: "vertical",
                }}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Event Venue */}
            <div>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                <i className="fa fa-map-marker-alt" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                Event Venue <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
              </label>
              <input
                type="text"
                value={eventVenue}
                onChange={(e) => setEventVenue(e.target.value)}
                placeholder="Enter event venue"
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  fontSize: "14px",
                  border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                  borderRadius: "8px",
                  transition: "all 0.3s ease",
                  outline: "none",
                }}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                  e.currentTarget.style.boxShadow = "none";
                }}
              />
            </div>

            {/* Event Type */}
            <div>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                <i className="fa fa-tag" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                Event Type <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
              </label>
              <select
                value={eventType}
                onChange={(e) => setEventType(e.target.value)}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  fontSize: "14px",
                  border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                  borderRadius: "8px",
                  transition: "all 0.3s ease",
                  outline: "none",
                  background: "#fff",
                  cursor: "pointer",
                }}
                onFocus={(e) => {
                  e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                  e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                }}
                onBlur={(e) => {
                  e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <option value="TRIP">TRIP</option>
                <option value="CULTURAL">CULTURAL</option>
                <option value="COMPETITIONAL">COMPETITIONAL</option>
              </select>
            </div>

            {/* Class/Section Selection */}
            <div>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                <i className="fa fa-users" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                Participating Class <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
                {selectedClasses.length > 0 && (
                  <span style={{ marginLeft: "8px", fontSize: "12px", color: COLORS.primary_color_shade6, fontWeight: 500 }}>
                    ({selectedClasses.length} selected)
                  </span>
                )}
              </label>

              {/* Board and Medium Filters */}
              {(classBoard.length > 0 || classMedium.length > 0) && (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "12px" }}>
                  {classBoard.length > 0 && (
                    <div>
                      <label style={{ display: "block", marginBottom: "6px", fontSize: "12px", fontWeight: 600, color: COLORS.black8 }}>
                        Board
                      </label>
                      <select
                        value={selectedBoardId}
                        onChange={(e) => setSelectedBoardId(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px 12px",
                          fontSize: "13px",
                          border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                          borderRadius: "6px",
                          outline: "none",
                          background: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        {classBoard.map((board) => (
                          <option key={board.board_id} value={board.board_id}>
                            {board.board_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {classMedium.length > 0 && (
                    <div>
                      <label style={{ display: "block", marginBottom: "6px", fontSize: "12px", fontWeight: 600, color: COLORS.black8 }}>
                        Medium
                      </label>
                      <select
                        value={selectedMediumId}
                        onChange={(e) => setSelectedMediumId(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "8px 12px",
                          fontSize: "13px",
                          border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                          borderRadius: "6px",
                          outline: "none",
                          background: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        {classMedium.map((medium) => (
                          <option key={medium.medium_id} value={medium.medium_id}>
                            {medium.medium_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              )}

              {/* Class Selection Grid */}
              {loadingClasses ? (
                <div style={{ padding: "20px", textAlign: "center" }}>
                  <MyLoader />
                </div>
              ) : mFilteredClassSectionList.length > 0 ? (
                <div style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  padding: "12px",
                  background: "#f8fafc",
                  borderRadius: "8px",
                  border: `1px solid ${COLORS.grey3 || "#E0E0E0"}`
                }}>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: "10px" }}>
                    {mFilteredClassSectionList.map((classItem, index) => {
                      const isSelected = isClassSelected(classItem);
                      const displayName = classItem.section_id === "No" || !classItem.section_id
                        ? classItem.class_name
                        : `${classItem.class_name}:${classItem.section_name}`;
                      
                      return (
                        <div
                          key={index}
                          onClick={() => handleClassToggle(classItem)}
                          style={{
                            padding: "10px 8px",
                            background: isSelected 
                              ? COLORS.primary_color_shade6 || "#3b82f6"
                              : "#fff",
                            color: isSelected ? "#fff" : COLORS.black8,
                            border: `2px solid ${isSelected 
                              ? COLORS.primary_color_shade6 || "#3b82f6"
                              : COLORS.grey3 || "#E0E0E0"}`,
                            borderRadius: "8px",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            textAlign: "center",
                            fontWeight: 600,
                            fontSize: "12px",
                            position: "relative",
                            minWidth: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          onMouseEnter={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#3b82f6";
                              e.currentTarget.style.background = COLORS.primary_color_shade1 || "#dbeafe";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                              e.currentTarget.style.background = "#fff";
                            }
                          }}
                          title={displayName}
                        >
                          {isSelected && (
                            <i 
                              className="fa fa-check-circle" 
                              style={{ 
                                position: "absolute", 
                                top: "4px", 
                                right: "4px",
                                fontSize: "14px"
                              }} 
                            />
                          )}
                          <span style={{ 
                            display: "block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                          }}>
                            {displayName}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div style={{ 
                  padding: "20px", 
                  textAlign: "center", 
                  color: COLORS.grey5 || "#9E9E9E",
                  background: "#f8fafc",
                  borderRadius: "8px",
                  border: `1px solid ${COLORS.grey3 || "#E0E0E0"}`
                }}>
                  No classes available. Please select board and medium.
                </div>
              )}

              {/* Selected Classes Summary */}
              {selectedClasses.length > 0 && (
                <div style={{ 
                  marginTop: "12px", 
                  padding: "10px", 
                  background: "#f0f9ff", 
                  borderRadius: "8px",
                  border: `1px solid ${COLORS.primary_color_shade4 || "#93c5fd"}`
                }}>
                  <div style={{ fontSize: "12px", fontWeight: 600, color: COLORS.primary_color_shade8 || "#1e40af", marginBottom: "6px" }}>
                    Participating Classes ({selectedClasses.length}):
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                    {selectedClasses.map((classItem, index) => (
                      <span
                        key={index}
                        style={{
                          padding: "4px 10px",
                          background: COLORS.primary_color_shade6 || "#3b82f6",
                          color: "#fff",
                          borderRadius: "6px",
                          fontSize: "12px",
                          fontWeight: 500,
                        }}
                      >
                        {classItem.section_id === "No" || !classItem.section_id
                          ? classItem.class_name
                          : `${classItem.class_name}:${classItem.section_name}`}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Paid Event */}
            <div>
              <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                <i className="fa fa-rupee-sign" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                Is Paid Event?
              </label>
              <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
                <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="isPaid"
                    value="No"
                    checked={isPaid === "No"}
                    onChange={(e) => {
                      setIsPaid(e.target.value);
                      if (e.target.value === "No") setEventFee("0");
                    }}
                  />
                  <span>No</span>
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
                  <input
                    type="radio"
                    name="isPaid"
                    value="Yes"
                    checked={isPaid === "Yes"}
                    onChange={(e) => setIsPaid(e.target.value)}
                  />
                  <span>Yes</span>
                </label>
              </div>
            </div>

            {/* Event Fee */}
            {isPaid === "Yes" && (
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                  <i className="fa fa-rupee-sign" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                  Event Fee <span style={{ color: COLORS.red5 || "#f44336" }}>*</span>
                </label>
                <input
                  type="number"
                  value={eventFee}
                  onChange={(e) => setEventFee(e.target.value)}
                  placeholder="Enter event fee"
                  min="0"
                  step="0.01"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    fontSize: "14px",
                    border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    outline: "none",
                  }}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer style={{ 
          borderTop: `1px solid ${COLORS.grey3 || "#E0E0E0"}`, 
          padding: "12px 24px",
          borderRadius: "0 0 10px 10px",
          overflow: "hidden",
        }}>
          <button
            onClick={handleCloseEventModal}
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
              background: COLORS.white,
              color: COLORS.black8 || "#333333",
              fontWeight: 600,
              fontSize: "14px",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = COLORS.grey2 || "#EEEEEE";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = COLORS.white;
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleCreateEvent}
            disabled={saving}
            style={{
              padding: "10px 24px",
              borderRadius: "8px",
              border: "none",
              background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#6366f1"} 100%)`,
              color: "#fff",
              fontWeight: 600,
              fontSize: "14px",
              cursor: saving ? "not-allowed" : "pointer",
              transition: "all 0.3s ease",
              opacity: saving ? 0.6 : 1,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
            onMouseEnter={(e) => {
              if (!saving) {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            {saving ? (
              <>
                <i className="fa fa-spinner fa-spin" />
                Creating...
              </>
            ) : (
              <>
                <i className="fa fa-check-circle" />
                Create Event
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Manage Instructions Modal */}
      <Modal
        show={isOpenInstructionModal}
        onHide={handleCloseInstructionModal}
        size="lg"
        centered
        animation={false}
        backdrop={true}
        keyboard={true}
        dialogClassName="event-instruction-modal"
      >
        <Modal.Header
          closeButton={false}
          style={{
            background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#6366f1"} 100%)`,
            color: "#fff",
            borderBottom: "none",
            borderRadius: "10px 10px 0 0",
            overflow: "hidden",
          }}
        >
          <Modal.Title style={{ color: "#fff", fontWeight: 700 }}>
            <i className="fa fa-info-circle" style={{ marginRight: "8px" }} />
            Manage Instructions - {selectedEventForInstruction?.event_name || ""}
          </Modal.Title>
          <button
            type="button"
            className="close"
            onClick={handleCloseInstructionModal}
            style={{ color: "#fff", opacity: 1 }}
          >
            <span>&times;</span>
          </button>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <div>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                <label style={{ fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                  <i className="fa fa-info-circle" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                  Event Instructions
                </label>
                <button
                  type="button"
                  onClick={handleAddEventInstruction}
                  style={{
                    padding: "6px 12px",
                    fontSize: "12px",
                    background: COLORS.primary_color_shade6 || "#3b82f6",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <i className="fa fa-plus" style={{ fontSize: "10px" }} />
                  Add Instruction
                </button>
              </div>
              {eventInstructions.map((instruction, index) => (
                <div key={index} style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                  <input
                    type="text"
                    value={instruction}
                    onChange={(e) => handleEventInstructionChange(index, e.target.value)}
                    placeholder={`Instruction ${index + 1}`}
                    maxLength={150}
                    style={{
                      flex: 1,
                      padding: "10px 14px",
                      fontSize: "14px",
                      border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                      borderRadius: "8px",
                      transition: "all 0.3s ease",
                      outline: "none",
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                      e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  />
                  {eventInstructions.length > 1 && (
                    <button
                      type="button"
                      onClick={() => handleRemoveEventInstruction(index)}
                      style={{
                        padding: "10px 14px",
                        background: COLORS.red5 || "#f44336",
                        color: "#fff",
                        border: "none",
                        borderRadius: "8px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      <i className="fa fa-times" />
                    </button>
                  )}
                </div>
              ))}
              <div style={{ fontSize: "12px", color: COLORS.grey5 || "#9E9E9E", marginTop: "8px" }}>
                <i className="fa fa-info-circle" style={{ marginRight: "4px" }} />
                Maximum 150 characters per instruction
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ 
          borderTop: `1px solid ${COLORS.grey3 || "#E0E0E0"}`, 
          padding: "12px 24px",
          borderRadius: "0 0 10px 10px",
          overflow: "hidden",
        }}>
          <button
            onClick={handleCloseInstructionModal}
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
              background: COLORS.white,
              color: COLORS.black8 || "#333333",
              fontWeight: 600,
              fontSize: "14px",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = COLORS.grey2 || "#EEEEEE";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = COLORS.white;
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSaveInstructions}
            disabled={saving}
            style={{
              padding: "10px 24px",
              borderRadius: "8px",
              border: "none",
              background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#6366f1"} 100%)`,
              color: "#fff",
              fontWeight: 600,
              fontSize: "14px",
              cursor: saving ? "not-allowed" : "pointer",
              transition: "all 0.3s ease",
              opacity: saving ? 0.6 : 1,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
            onMouseEnter={(e) => {
              if (!saving) {
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            {saving ? (
              <>
                <i className="fa fa-spinner fa-spin" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa fa-save" />
                Save Instructions
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Manage Group Modal */}
      <Modal
        show={isOpenGroupModal}
        onHide={handleCloseGroupModal}
        size="lg"
        centered
        animation={false}
      >
        <Modal.Header
          closeButton
          style={{
            background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#1e40af"} 100%)`,
            color: COLORS.white,
            border: "none",
          }}
        >
          <Modal.Title>
            <i className="fa fa-layer-group" style={{ marginRight: "8px" }} />
            Manage Participant Groups
            {selectedEventForGroup && (
              <span style={{ fontSize: "14px", fontWeight: 400, marginLeft: "10px" }}>
                - {selectedEventForGroup.event_name}
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          {selectedEventForGroup && (
            <ManageGroupContent
              event={selectedEventForGroup}
              sessionId={sessionId}
              onClose={handleCloseGroupModal}
              onRefresh={() => getEventList(sessionId)}
            />
          )}
        </Modal.Body>
      </Modal>

      {/* Share Event Modal */}
      <Modal
        show={isOpenShareModal}
        onHide={handleCloseShareModal}
        size="md"
        centered
        animation={false}
        backdrop={true}
        keyboard={true}
        dialogClassName="share-event-modal"
      >
        <Modal.Header
          closeButton={false}
          style={{
            background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#6366f1"} 100%)`,
            color: "#fff",
            borderBottom: "none",
            borderRadius: "0",
            padding: "20px 24px",
            margin: "0",
          }}
        >
          <Modal.Title style={{ color: "#fff", fontWeight: 700 }}>
            <i className="fa fa-share-alt" style={{ marginRight: "8px" }} />
            Share Event
            {selectedEventForShare && (
              <span style={{ fontSize: "14px", fontWeight: 400, marginLeft: "10px" }}>
                - {selectedEventForShare.event_name}
              </span>
            )}
          </Modal.Title>
          <button
            type="button"
            className="close"
            onClick={handleCloseShareModal}
            style={{ color: "#fff", opacity: 1 }}
          >
            <span>&times;</span>
          </button>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px", borderRadius: "0", margin: "0" }}>
          {selectedEventForShare && (
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
              {/* Shareable Link Display */}
              <div>
                <label style={{ display: "block", marginBottom: "8px", fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                  <i className="fa fa-link" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                  Shareable Link
                </label>
                <div style={{ display: "flex", gap: "8px" }}>
                  <input
                    type="text"
                    value={getShareableLink(selectedEventForShare.event_id)}
                    readOnly
                    style={{
                      flex: 1,
                      padding: "12px 16px",
                      fontSize: "13px",
                      border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                      borderRadius: "8px",
                      background: "#f8fafc",
                      color: COLORS.black8 || "#333333",
                      fontFamily: "monospace",
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => handleCopyShareableLink(selectedEventForShare.event_id)}
                    style={{
                      padding: "12px 20px",
                      background: COLORS.primary_color_shade6 || "#3b82f6",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: 600,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      transition: "all 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = COLORS.primary_color_shade7 || "#4f46e5";
                      e.currentTarget.style.transform = "translateY(-1px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = COLORS.primary_color_shade6 || "#3b82f6";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    <i className="fa fa-copy" />
                    Copy
                  </button>
                </div>
              </div>

              {/* Share Options */}
              <div>
                <label style={{ display: "block", marginBottom: "12px", fontSize: "14px", fontWeight: 600, color: COLORS.black8 || "#333333" }}>
                  <i className="fa fa-share-alt" style={{ marginRight: "6px", color: COLORS.primary_color_shade6 }} />
                  Share On
                </label>
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <button
                    type="button"
                    onClick={() => handleShareOnWhatsApp(selectedEventForShare.event_id, selectedEventForShare.event_name)}
                    style={{
                      width: "100%",
                      padding: "14px 20px",
                      background: "#25D366",
                      color: "#fff",
                      border: "none",
                      borderRadius: "10px",
                      fontSize: "15px",
                      fontWeight: 600,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      transition: "all 0.2s ease",
                      boxShadow: "0 2px 8px rgba(37, 211, 102, 0.2)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#20BA5A";
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(37, 211, 102, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "#25D366";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 2px 8px rgba(37, 211, 102, 0.2)";
                    }}
                  >
                    <i className="fa fa-whatsapp" style={{ fontSize: "20px" }} />
                    Share on WhatsApp
                  </button>
                </div>
              </div>

              {/* Info Message */}
              <div style={{
                padding: "12px 16px",
                background: COLORS.primary_color_shade1 || "#eff6ff",
                border: `1px solid ${COLORS.primary_color_shade4 || "#93c5fd"}`,
                borderRadius: "8px",
                fontSize: "13px",
                color: COLORS.primary_color_shade8 || "#1e40af",
                display: "flex",
                alignItems: "flex-start",
                gap: "10px",
              }}>
                <i className="fa fa-info-circle" style={{ marginTop: "2px", fontSize: "16px" }} />
                <div>
                  <strong>Note:</strong> Share this link with event participants. They can use it to view event details and participant information.
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* Manage Program Modal */}
      <Modal
        show={isOpenProgramModal}
        onHide={handleCloseProgramModal}
        size="lg"
        centered
        animation={false}
        backdrop={true}
        keyboard={true}
        dialogClassName="manage-program-modal"
      >
        <Modal.Header
          closeButton={false}
          style={{
            background: `linear-gradient(135deg, #f59e0b 0%, #d97706 100%)`,
            color: "#fff",
            borderBottom: "none",
            borderRadius: "10px 10px 0 0",
            padding: "20px 24px",
            margin: "0",
          }}
        >
          <Modal.Title style={{ color: "#fff", fontWeight: 700 }}>
            <i className="fa fa-calendar-alt" style={{ marginRight: "8px" }} />
            Manage Programs
            {selectedEventForProgram && (
              <span style={{ fontSize: "14px", fontWeight: 400, marginLeft: "10px" }}>
                - {selectedEventForProgram.event_name}
              </span>
            )}
          </Modal.Title>
          <button
            type="button"
            className="close"
            onClick={handleCloseProgramModal}
            style={{ color: "#fff", opacity: 1, position: "absolute", right: "20px", top: "20px" }}
          >
            <span>&times;</span>
          </button>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px", borderRadius: "0 0 10px 10px" }}>
          {selectedEventForProgram && (
            <ManageProgramContent
              event={selectedEventForProgram}
              sessionId={sessionId}
              onClose={handleCloseProgramModal}
              onRefresh={() => getEventList(sessionId)}
            />
          )}
        </Modal.Body>
      </Modal>

      {/* Manage Class Modal */}
      <Modal
        show={isOpenClassModal}
        onHide={handleCloseClassModal}
        size="lg"
        centered
        animation={false}
        backdrop={true}
        keyboard={true}
        dialogClassName="manage-class-modal"
      >
        <Modal.Header
          closeButton={false}
          style={{
            background: `linear-gradient(135deg, #16a34a 0%, #15803d 100%)`,
            color: "#fff",
            borderBottom: "none",
            borderRadius: "10px 10px 0 0",
            padding: "20px 24px",
            margin: "0",
          }}
        >
          <Modal.Title style={{ color: "#fff", fontWeight: 700 }}>
            <i className="fa fa-users" style={{ marginRight: "8px" }} />
            Manage Participating Classes
            {selectedEventForClass && (
              <span style={{ fontSize: "14px", fontWeight: 400, marginLeft: "10px" }}>
                - {selectedEventForClass.event_name}
              </span>
            )}
          </Modal.Title>
          <button
            type="button"
            className="close"
            onClick={handleCloseClassModal}
            style={{ color: "#fff", opacity: 1, position: "absolute", right: "20px", top: "20px" }}
          >
            <span>&times;</span>
          </button>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px", borderRadius: "0 0 10px 10px" }}>
          {selectedEventForClass && (
            <ManageClassContent
              event={selectedEventForClass}
              sessionId={sessionId}
              onClose={handleCloseClassModal}
              onRefresh={() => getEventList(sessionId)}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

// Manage Group Content Component - Memoized to prevent unnecessary re-renders
const ManageGroupContent = memo(({ event, sessionId, onClose, onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [newGroupName, setNewGroupName] = useState("");
  const [editingGroupId, setEditingGroupId] = useState(null);
  const [editingGroupName, setEditingGroupName] = useState("");

  const getGroups = useCallback(() => {
    if (!event?.event_id || !sessionId) return;
    
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getEventParticipantGroups.php`;

    axios
      .get(URL, {
        params: {
          event_id: event.event_id,
          session_id: sessionId,
          school_code: SCHOOL_CODE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK" && Array.isArray(response.data)) {
          setGroups(response.data || []);
        } else {
          myToast.notify_warning(response.api_remark || "Failed to load groups");
          setGroups([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching groups:", error);
        myToast.notify_error("Error loading groups");
        setGroups([]);
      });
  }, [event?.event_id, sessionId]);

  useEffect(() => {
    getGroups();
  }, [getGroups]);

  const handleAddGroup = useCallback(() => {
    if (!newGroupName.trim()) {
      myToast.notify_warning("Please enter a group name");
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}AddEventParticipantGroup.php`;

    axios
      .get(URL, {
        params: {
          event_id: event.event_id,
          session_id: sessionId,
          school_code: SCHOOL_CODE,
          group_name: newGroupName.trim(),
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Group added successfully");
          setNewGroupName("");
          getGroups();
          onRefresh();
        } else {
          myToast.notify_warning(response.api_remark || "Failed to add group");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error adding group:", error);
        myToast.notify_error("Error adding group");
      });
  }, [event?.event_id, sessionId, newGroupName, getGroups, onRefresh]);

  const handleEditGroup = useCallback((group) => {
    setEditingGroupId(group.group_id);
    setEditingGroupName(group.group_name);
  }, []);

  const handleUpdateGroup = useCallback(() => {
    if (!editingGroupName.trim()) {
      myToast.notify_warning("Please enter a group name");
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}UpdateEventParticipantGroup.php`;

    axios
      .get(URL, {
        params: {
          group_id: editingGroupId,
          group_name: editingGroupName.trim(),
          school_code: SCHOOL_CODE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Group updated successfully");
          setEditingGroupId(null);
          setEditingGroupName("");
          getGroups();
          onRefresh();
        } else {
          myToast.notify_warning(response.api_remark || "Failed to update group");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error updating group:", error);
        myToast.notify_error("Error updating group");
      });
  }, [editingGroupId, editingGroupName, getGroups, onRefresh]);

  const handleDeleteGroup = useCallback((group) => {
    if (!window.confirm(`Are you sure you want to delete the group "${group.group_name}"?`)) {
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}DeleteEventParticipantGroup.php`;

    axios
      .get(URL, {
        params: {
          group_id: group.group_id,
          school_code: SCHOOL_CODE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Group deleted successfully");
          getGroups();
          onRefresh();
        } else {
          myToast.notify_warning(response.api_remark || "Failed to delete group");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error deleting group:", error);
        myToast.notify_error("Error deleting group");
      });
  }, [getGroups, onRefresh]);

  if (loading && groups.length === 0) {
    return <MyLoader />;
  }

  return (
    <div>
      {/* Add New Group */}
      <div style={{ marginBottom: "24px", padding: "16px", background: "#f8fafc", borderRadius: "10px" }}>
        <h6 style={{ margin: "0 0 12px 0", fontSize: "16px", fontWeight: 600, color: COLORS.black8 }}>
          Add New Group
        </h6>
        <div style={{ display: "flex", gap: "10px" }}>
          <input
            type="text"
            value={newGroupName}
            onChange={(e) => setNewGroupName(e.target.value)}
            placeholder="Enter group name"
            style={{
              flex: 1,
              padding: "10px 14px",
              fontSize: "14px",
              border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
              borderRadius: "8px",
              outline: "none",
            }}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleAddGroup();
              }
            }}
          />
          <button
            type="button"
            onClick={handleAddGroup}
            disabled={loading}
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#3b82f6"} 0%, ${COLORS.primary_color_shade8 || "#1e40af"} 100%)`,
              color: "#fff",
              fontWeight: 600,
              fontSize: "14px",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.6 : 1,
            }}
          >
            <i className="fa fa-plus" style={{ marginRight: "6px" }} />
            Add
          </button>
        </div>
      </div>

      {/* Groups List */}
      <div>
        <h6 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: 600, color: COLORS.black8 }}>
          Existing Groups
        </h6>
        {groups.length === 0 ? (
          <div style={{ padding: "40px", textAlign: "center", color: "#6b7280" }}>
            <i className="fa fa-layer-group" style={{ fontSize: "48px", marginBottom: "16px", opacity: 0.3 }} />
            <p>No groups found. Add a new group to get started.</p>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {groups.map((group) => (
              <div
                key={group.group_id}
                style={{
                  padding: "14px 16px",
                  background: COLORS.white,
                  border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "12px",
                }}
              >
                {editingGroupId === group.group_id ? (
                  <>
                    <input
                      type="text"
                      value={editingGroupName}
                      onChange={(e) => setEditingGroupName(e.target.value)}
                      style={{
                        flex: 1,
                        padding: "8px 12px",
                        fontSize: "14px",
                        border: `2px solid ${COLORS.primary_color_shade6}`,
                        borderRadius: "6px",
                        outline: "none",
                      }}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          handleUpdateGroup();
                        }
                      }}
                    />
                    <button
                      type="button"
                      onClick={handleUpdateGroup}
                      disabled={loading}
                      style={{
                        padding: "8px 16px",
                        borderRadius: "6px",
                        border: "none",
                        background: COLORS.primary_color_shade6,
                        color: "#fff",
                        fontSize: "13px",
                        cursor: loading ? "not-allowed" : "pointer",
                      }}
                    >
                      <i className="fa fa-check" />
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setEditingGroupId(null);
                        setEditingGroupName("");
                      }}
                      style={{
                        padding: "8px 16px",
                        borderRadius: "6px",
                        border: `2px solid ${COLORS.grey3}`,
                        background: COLORS.white,
                        fontSize: "13px",
                        cursor: "pointer",
                      }}
                    >
                      <i className="fa fa-times" />
                    </button>
                  </>
                ) : (
                  <>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: "15px", fontWeight: 600, color: COLORS.black8 }}>
                        {group.group_name}
                      </div>
                      <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px" }}>
                        Group ID: {group.group_id}
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => handleEditGroup(group)}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "6px",
                        border: `2px solid ${COLORS.primary_color_shade6}`,
                        background: COLORS.white,
                        color: COLORS.primary_color_shade6,
                        fontSize: "13px",
                        cursor: "pointer",
                      }}
                    >
                      <i className="fa fa-edit" style={{ marginRight: "4px" }} />
                      Edit
                    </button>
                    <button
                      type="button"
                      onClick={() => handleDeleteGroup(group)}
                      disabled={loading}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "6px",
                        border: "none",
                        background: "#ef4444",
                        color: "#fff",
                        fontSize: "13px",
                        cursor: loading ? "not-allowed" : "pointer",
                      }}
                    >
                      <i className="fa fa-trash" />
                    </button>
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
});

ManageGroupContent.displayName = 'ManageGroupContent';

// Manage Program Content Component - Memoized to prevent unnecessary re-renders
const ManageProgramContent = memo(({ event, sessionId, onClose, onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [newProgramName, setNewProgramName] = useState("");
  const [newProgramDate, setNewProgramDate] = useState("");
  const [newProgramTime, setNewProgramTime] = useState("10:30");
  const [newShift, setNewShift] = useState("FIRST");
  const [editingProgramId, setEditingProgramId] = useState(null);
  const [editingProgramName, setEditingProgramName] = useState("");
  const [editingProgramDate, setEditingProgramDate] = useState("");
  const [editingProgramTime, setEditingProgramTime] = useState("");
  const [editingShift, setEditingShift] = useState("FIRST");

  const getPrograms = useCallback(() => {
    if (!event?.event_id || !sessionId) return;
    
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getEventPrograms.php`;

    axios
      .get(URL, {
        params: {
          event_id: event.event_id,
          session_id: sessionId,
          school_code: SCHOOL_CODE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK" && Array.isArray(response.data)) {
          setPrograms(response.data || []);
        } else {
          myToast.notify_warning(response.api_remark || "Failed to load programs");
          setPrograms([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching programs:", error);
        myToast.notify_error("Error loading programs");
        setPrograms([]);
      });
  }, [event?.event_id, sessionId]);

  useEffect(() => {
    getPrograms();
  }, [getPrograms]);

  const handleAddProgram = useCallback(() => {
    if (!newProgramName.trim()) {
      myToast.notify_warning("Please enter a program name");
      return;
    }
    if (!newProgramDate) {
      myToast.notify_warning("Please select a program date");
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}AddEventProgram.php`;

    // Format time to HH:MM:SS AM/PM format
    const timeParts = newProgramTime.split(':');
    const hours = parseInt(timeParts[0]);
    const minutes = timeParts[1] || '00';
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const hours12 = hours % 12 || 12;
    const formattedTime = `${hours12}:${minutes}:00 ${ampm}`;

    axios
      .get(URL, {
        params: {
          event_id: event.event_id,
          session_id: sessionId,
          school_code: SCHOOL_CODE,
          program_name: newProgramName.trim(),
          program_date: newProgramDate,
          program_time: formattedTime,
          shift: newShift,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Program added successfully");
          setNewProgramName("");
          setNewProgramDate("");
          setNewProgramTime("10:30");
          setNewShift("FIRST");
          getPrograms();
          onRefresh();
        } else {
          myToast.notify_warning(response.api_remark || "Failed to add program");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error adding program:", error);
        myToast.notify_error("Error adding program");
      });
  }, [event?.event_id, sessionId, newProgramName, newProgramDate, newProgramTime, newShift, getPrograms, onRefresh]);

  const handleEditProgram = useCallback((program) => {
    setEditingProgramId(program.program_id);
    setEditingProgramName(program.program_name);
    setEditingProgramDate(program.program_date);
    
    // Parse time from "HH:MM:SS AM/PM" format to "HH:MM" for input
    const timeStr = program.program_time || "10:30:00 AM";
    const timeMatch = timeStr.match(/(\d+):(\d+):\d+\s*(AM|PM)/i);
    if (timeMatch) {
      let hours = parseInt(timeMatch[1]);
      const minutes = timeMatch[2];
      const ampm = timeMatch[3].toUpperCase();
      if (ampm === 'PM' && hours !== 12) hours += 12;
      if (ampm === 'AM' && hours === 12) hours = 0;
      setEditingProgramTime(`${hours.toString().padStart(2, '0')}:${minutes}`);
    } else {
      setEditingProgramTime("10:30");
    }
    
    setEditingShift(program.shift || "FIRST");
  }, []);

  const handleUpdateProgram = useCallback(() => {
    if (!editingProgramName.trim()) {
      myToast.notify_warning("Please enter a program name");
      return;
    }
    if (!editingProgramDate) {
      myToast.notify_warning("Please select a program date");
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}UpdateEventProgram.php`;

    // Format time to HH:MM:SS AM/PM format
    const timeParts = editingProgramTime.split(':');
    const hours = parseInt(timeParts[0]);
    const minutes = timeParts[1] || '00';
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const hours12 = hours % 12 || 12;
    const formattedTime = `${hours12}:${minutes}:00 ${ampm}`;

    axios
      .get(URL, {
        params: {
          program_id: editingProgramId,
          program_name: editingProgramName.trim(),
          program_date: editingProgramDate,
          program_time: formattedTime,
          shift: editingShift,
          school_code: SCHOOL_CODE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Program updated successfully");
          setEditingProgramId(null);
          setEditingProgramName("");
          setEditingProgramDate("");
          setEditingProgramTime("");
          setEditingShift("FIRST");
          getPrograms();
          onRefresh();
        } else {
          myToast.notify_warning(response.api_remark || "Failed to update program");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error updating program:", error);
        myToast.notify_error("Error updating program");
      });
  }, [editingProgramId, editingProgramName, editingProgramDate, editingProgramTime, editingShift, getPrograms, onRefresh]);

  const handleDeleteProgram = useCallback((program) => {
    if (!window.confirm(`Are you sure you want to delete the program "${program.program_name}"?`)) {
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}DeleteEventProgram.php`;

    axios
      .get(URL, {
        params: {
          program_id: program.program_id,
          school_code: SCHOOL_CODE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Program deleted successfully");
          getPrograms();
          onRefresh();
        } else {
          myToast.notify_warning(response.api_remark || "Failed to delete program");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error deleting program:", error);
        myToast.notify_error("Error deleting program");
      });
  }, [getPrograms, onRefresh]);

  const formatDate = useCallback((dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch (error) {
      return dateString;
    }
  }, []);

  if (loading && programs.length === 0) {
    return <MyLoader />;
  }

  return (
    <div>
      {/* Add New Program */}
      <div style={{ marginBottom: "24px", padding: "16px", background: "#fef3c7", borderRadius: "10px", border: "2px solid #f59e0b" }}>
        <h6 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: 600, color: "#92400e" }}>
          <i className="fa fa-plus-circle" style={{ marginRight: "8px" }} />
          Add New Program
        </h6>
        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "12px" }}>
          <div>
            <label style={{ display: "block", marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#78350f" }}>
              Program Name <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <input
              type="text"
              value={newProgramName}
              onChange={(e) => setNewProgramName(e.target.value)}
              placeholder="Enter program name"
              style={{
                width: "100%",
                padding: "10px 14px",
                fontSize: "14px",
                border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                borderRadius: "8px",
                outline: "none",
              }}
            />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "10px" }}>
            <div>
              <label style={{ display: "block", marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#78350f" }}>
                Date <span style={{ color: "#dc2626" }}>*</span>
              </label>
              <input
                type="date"
                value={newProgramDate}
                onChange={(e) => setNewProgramDate(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  fontSize: "14px",
                  border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                  borderRadius: "8px",
                  outline: "none",
                }}
              />
            </div>
            <div>
              <label style={{ display: "block", marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#78350f" }}>
                Time
              </label>
              <input
                type="time"
                value={newProgramTime}
                onChange={(e) => setNewProgramTime(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  fontSize: "14px",
                  border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                  borderRadius: "8px",
                  outline: "none",
                }}
              />
            </div>
            <div>
              <label style={{ display: "block", marginBottom: "6px", fontSize: "13px", fontWeight: 600, color: "#78350f" }}>
                Shift
              </label>
              <select
                value={newShift}
                onChange={(e) => setNewShift(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  fontSize: "14px",
                  border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                  borderRadius: "8px",
                  outline: "none",
                  background: "#fff",
                  cursor: "pointer",
                }}
              >
                <option value="FIRST">FIRST</option>
                <option value="SECOND">SECOND</option>
              </select>
            </div>
          </div>
          <button
            type="button"
            onClick={handleAddProgram}
            disabled={loading}
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              background: `linear-gradient(135deg, #f59e0b 0%, #d97706 100%)`,
              color: "#fff",
              fontWeight: 600,
              fontSize: "14px",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.6 : 1,
            }}
          >
            <i className="fa fa-plus" style={{ marginRight: "6px" }} />
            Add Program
          </button>
        </div>
      </div>

      {/* Programs List */}
      <div>
        <h6 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: 600, color: COLORS.black8 }}>
          Existing Programs
        </h6>
        {programs.length === 0 ? (
          <div style={{ padding: "40px", textAlign: "center", color: "#6b7280" }}>
            <i className="fa fa-calendar-alt" style={{ fontSize: "48px", marginBottom: "16px", opacity: 0.3 }} />
            <p>No programs found. Add a new program to get started.</p>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {programs.map((program) => (
              <div
                key={program.program_id}
                style={{
                  padding: "14px 16px",
                  background: COLORS.white,
                  border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {editingProgramId === program.program_id ? (
                  <>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "10px" }}>
                      <input
                        type="text"
                        value={editingProgramName}
                        onChange={(e) => setEditingProgramName(e.target.value)}
                        placeholder="Program name"
                        style={{
                          width: "100%",
                          padding: "8px 12px",
                          fontSize: "14px",
                          border: `2px solid #f59e0b`,
                          borderRadius: "6px",
                          outline: "none",
                        }}
                      />
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "10px" }}>
                        <input
                          type="date"
                          value={editingProgramDate}
                          onChange={(e) => setEditingProgramDate(e.target.value)}
                          style={{
                            padding: "8px 12px",
                            fontSize: "14px",
                            border: `2px solid #f59e0b`,
                            borderRadius: "6px",
                            outline: "none",
                          }}
                        />
                        <input
                          type="time"
                          value={editingProgramTime}
                          onChange={(e) => setEditingProgramTime(e.target.value)}
                          style={{
                            padding: "8px 12px",
                            fontSize: "14px",
                            border: `2px solid #f59e0b`,
                            borderRadius: "6px",
                            outline: "none",
                          }}
                        />
                        <select
                          value={editingShift}
                          onChange={(e) => setEditingShift(e.target.value)}
                          style={{
                            padding: "8px 12px",
                            fontSize: "14px",
                            border: `2px solid #f59e0b`,
                            borderRadius: "6px",
                            outline: "none",
                            background: "#fff",
                            cursor: "pointer",
                          }}
                        >
                          <option value="FIRST">FIRST</option>
                          <option value="SECOND">SECOND</option>
                        </select>
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                      <button
                        type="button"
                        onClick={handleUpdateProgram}
                        disabled={loading}
                        style={{
                          padding: "8px 16px",
                          borderRadius: "6px",
                          border: "none",
                          background: "#f59e0b",
                          color: "#fff",
                          fontSize: "13px",
                          cursor: loading ? "not-allowed" : "pointer",
                        }}
                      >
                        <i className="fa fa-check" style={{ marginRight: "4px" }} />
                        Save
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setEditingProgramId(null);
                          setEditingProgramName("");
                          setEditingProgramDate("");
                          setEditingProgramTime("");
                          setEditingShift("FIRST");
                        }}
                        style={{
                          padding: "8px 16px",
                          borderRadius: "6px",
                          border: `2px solid ${COLORS.grey3}`,
                          background: COLORS.white,
                          fontSize: "13px",
                          cursor: "pointer",
                        }}
                      >
                        <i className="fa fa-times" style={{ marginRight: "4px" }} />
                        Cancel
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: "15px", fontWeight: 600, color: COLORS.black8 }}>
                          {program.program_name}
                        </div>
                        <div style={{ fontSize: "12px", color: "#6b7280", marginTop: "4px" }}>
                          <span style={{ marginRight: "12px" }}>
                            <i className="fa fa-calendar" style={{ marginRight: "4px" }} />
                            {formatDate(program.program_date)}
                          </span>
                          <span style={{ marginRight: "12px" }}>
                            <i className="fa fa-clock" style={{ marginRight: "4px" }} />
                            {program.program_time}
                          </span>
                          <span>
                            <i className="fa fa-sun" style={{ marginRight: "4px" }} />
                            SHIFT: {program.shift}
                          </span>
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={() => handleEditProgram(program)}
                        style={{
                          padding: "8px 14px",
                          borderRadius: "6px",
                          border: `2px solid #f59e0b`,
                          background: COLORS.white,
                          color: "#f59e0b",
                          fontSize: "13px",
                          cursor: "pointer",
                        }}
                      >
                        <i className="fa fa-edit" style={{ marginRight: "4px" }} />
                        Edit
                      </button>
                      <button
                        type="button"
                        onClick={() => handleDeleteProgram(program)}
                        disabled={loading}
                        style={{
                          padding: "8px 14px",
                          borderRadius: "6px",
                          border: "none",
                          background: "#ef4444",
                          color: "#fff",
                          fontSize: "13px",
                          cursor: loading ? "not-allowed" : "pointer",
                        }}
                      >
                        <i className="fa fa-trash" />
                      </button>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
});

ManageProgramContent.displayName = 'ManageProgramContent';

// Manage Class Content Component - Memoized to prevent unnecessary re-renders
const ManageClassContent = memo(({ event, sessionId, onClose, onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [eventClasses, setEventClasses] = useState([]);
  const [schoolClasses, setSchoolClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState("");
  const [newClassName, setNewClassName] = useState("");
  const [editingClassId, setEditingClassId] = useState(null);
  const [editingClassName, setEditingClassName] = useState("");

  const getEventClasses = useCallback(() => {
    if (!event?.event_id || !sessionId) return;
    
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getEventClasses.php`;

    console.log("getEventClasses - Calling API with params:", {
      event_id: event.event_id,
      session_id: sessionId,
      school_code: SCHOOL_CODE
    });

    axios
      .get(URL, {
        params: {
          event_id: event.event_id,
          session_id: sessionId,
          school_code: SCHOOL_CODE,
        },
      })
      .then((res) => {
        console.log("getEventClasses - Raw response:", res);
        console.log("getEventClasses - Response data:", res.data);
        return res.data;
      })
      .then((response) => {
        setLoading(false);
        console.log("getEventClasses - Parsed response:", response);
        if (response.api_status === "OK") {
          if (Array.isArray(response.data)) {
            console.log("getEventClasses - Setting classes:", response.data);
            setEventClasses(response.data || []);
          } else {
            console.warn("getEventClasses - response.data is not an array:", response.data);
            setEventClasses([]);
          }
        } else {
          console.error("getEventClasses - API Error:", response.api_remark);
          myToast.notify_warning(response.api_remark || "Failed to load classes");
          setEventClasses([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("getEventClasses - Error fetching event classes:", error);
        console.error("getEventClasses - Error response:", error.response);
        console.error("getEventClasses - Error message:", error.message);
        myToast.notify_error("Error loading classes: " + (error.response?.data?.api_remark || error.message));
        setEventClasses([]);
      });
  }, [event?.event_id, sessionId]);

  const getSchoolClasses = useCallback(() => {
    if (!sessionId) return;
    
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}getClass.php`;

    console.log("getSchoolClasses - Calling API with params:", {
      school_code: SCHOOL_CODE,
      session_id: sessionId
    });

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          session_id: sessionId,
        },
      })
      .then((res) => {
        console.log("getSchoolClasses - Raw response:", res);
        console.log("getSchoolClasses - Response data:", res.data);
        return res.data;
      })
      .then((response) => {
        console.log("getSchoolClasses - Parsed response:", response);
        if (response.api_status === "OK") {
          if (response.data && Array.isArray(response.data.class)) {
            console.log("getSchoolClasses - Setting school classes:", response.data.class);
            setSchoolClasses(response.data.class || []);
          } else {
            console.warn("getSchoolClasses - response.data.class is not an array:", response.data);
            setSchoolClasses([]);
          }
        } else {
          console.error("getSchoolClasses - API Error:", response.api_remark);
          setSchoolClasses([]);
        }
      })
      .catch((error) => {
        console.error("getSchoolClasses - Error fetching school classes:", error);
        console.error("getSchoolClasses - Error response:", error.response);
        console.error("getSchoolClasses - Error message:", error.message);
        setSchoolClasses([]);
      });
  }, [sessionId]);

  useEffect(() => {
    getEventClasses();
    getSchoolClasses();
  }, [getEventClasses, getSchoolClasses]);

  // Filter out classes that are already added to the event
  const availableSchoolClasses = useMemo(() => {
    console.log("availableSchoolClasses - eventClasses:", eventClasses);
    console.log("availableSchoolClasses - schoolClasses:", schoolClasses);
    
    if (!Array.isArray(eventClasses) || !Array.isArray(schoolClasses)) {
      console.warn("availableSchoolClasses - One or both arrays are not arrays");
      return [];
    }
    
    const addedClassIds = new Set(eventClasses.map(ec => ec.class_id).filter(id => id));
    console.log("availableSchoolClasses - Added class IDs:", Array.from(addedClassIds));
    
    const available = schoolClasses.filter(sc => {
      const hasClassId = sc && sc.class_id;
      const isNotAdded = !addedClassIds.has(sc.class_id);
      return hasClassId && isNotAdded;
    });
    
    console.log("availableSchoolClasses - Available classes:", available);
    return available;
  }, [schoolClasses, eventClasses]);

  const handleAddFromExisting = useCallback(() => {
    if (!selectedClassId) {
      myToast.notify_warning("Please select a class");
      return;
    }

    if (!event?.event_id) {
      myToast.notify_warning("Event ID is missing");
      console.error("handleAddFromExisting: event.event_id is missing");
      return;
    }

    const selectedClass = schoolClasses.find(sc => sc.class_id === selectedClassId);
    if (!selectedClass) {
      myToast.notify_warning("Selected class not found");
      console.error("handleAddFromExisting: Selected class not found in schoolClasses:", selectedClassId);
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}AddEventClass.php`;

    const params = {
      event_id: event.event_id,
      session_id: sessionId,
      school_code: SCHOOL_CODE,
      class_id: selectedClassId,
      class_name: selectedClass.class_name || "",
    };

    console.log("handleAddFromExisting - Calling API with params:", params);
    console.log("handleAddFromExisting - Full URL:", URL + "?" + new URLSearchParams(params).toString());

    axios
      .get(URL, { params })
      .then((res) => {
        console.log("AddEventClass (from existing) - Raw response:", res);
        console.log("AddEventClass (from existing) - Response data:", res.data);
        return res.data;
      })
      .then((response) => {
        setLoading(false);
        console.log("AddEventClass (from existing) - Parsed response:", response);
        if (response.api_status === "OK") {
          myToast.notify_success("Class added successfully");
          setSelectedClassId("");
          getEventClasses();
          getSchoolClasses();
          onRefresh();
        } else {
          console.error("AddEventClass (from existing) - API Error:", response.api_remark);
          myToast.notify_warning(response.api_remark || "Failed to add class");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("AddEventClass (from existing) - Error adding class:", error);
        console.error("AddEventClass (from existing) - Error response:", error.response);
        console.error("AddEventClass (from existing) - Error message:", error.message);
        const errorMsg = error.response?.data?.api_remark || error.message || "Unknown error occurred";
        myToast.notify_error("Error adding class: " + errorMsg);
      });
  }, [event?.event_id, sessionId, selectedClassId, schoolClasses, getEventClasses, getSchoolClasses, onRefresh]);

  const handleAddNewEntry = useCallback(() => {
    if (!newClassName.trim()) {
      myToast.notify_warning("Please enter a class name");
      return;
    }

    if (!event?.event_id) {
      myToast.notify_warning("Event ID is missing");
      console.error("handleAddNewEntry: event.event_id is missing");
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}AddEventClass.php`;

    // Generate a temporary class_id for new entries
    const tempClassId = "TEMP_" + Date.now();

    const params = {
      event_id: event.event_id,
      session_id: sessionId,
      school_code: SCHOOL_CODE,
      class_id: tempClassId,
      class_name: newClassName.trim(),
    };

    console.log("handleAddNewEntry - Calling API with params:", params);
    console.log("handleAddNewEntry - Full URL:", URL + "?" + new URLSearchParams(params).toString());

    axios
      .get(URL, { params })
      .then((res) => {
        console.log("AddEventClass (new entry) - Raw response:", res);
        console.log("AddEventClass (new entry) - Response data:", res.data);
        return res.data;
      })
      .then((response) => {
        setLoading(false);
        console.log("AddEventClass (new entry) - Parsed response:", response);
        if (response.api_status === "OK") {
          myToast.notify_success("Class added successfully");
          setNewClassName("");
          getEventClasses();
          onRefresh();
        } else {
          console.error("AddEventClass (new entry) - API Error:", response.api_remark);
          myToast.notify_warning(response.api_remark || "Failed to add class");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("AddEventClass (new entry) - Error adding class:", error);
        console.error("AddEventClass (new entry) - Error response:", error.response);
        console.error("AddEventClass (new entry) - Error message:", error.message);
        const errorMsg = error.response?.data?.api_remark || error.message || "Unknown error occurred";
        myToast.notify_error("Error adding class: " + errorMsg);
      });
  }, [event?.event_id, sessionId, newClassName, getEventClasses, onRefresh]);

  const handleEditClass = useCallback((eventClass) => {
    setEditingClassId(eventClass.class_id);
    setEditingClassName(eventClass.class_name);
  }, []);

  const handleUpdateClass = useCallback(() => {
    if (!editingClassName.trim()) {
      myToast.notify_warning("Please enter a class name");
      return;
    }

    if (!editingClassId) {
      myToast.notify_warning("Class ID is missing");
      console.error("handleUpdateClass: editingClassId is missing");
      return;
    }

    if (!event?.event_id) {
      myToast.notify_warning("Event ID is missing");
      console.error("handleUpdateClass: event.event_id is missing");
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}UpdateEventClass.php`;

    const params = {
      event_id: event.event_id,
      class_id: editingClassId,
      class_name: editingClassName.trim(),
      session_id: sessionId,
      school_code: SCHOOL_CODE,
    };

    console.log("handleUpdateClass - Calling API with params:", params);
    console.log("handleUpdateClass - Full URL:", URL + "?" + new URLSearchParams(params).toString());

    axios
      .get(URL, { params })
      .then((res) => {
        console.log("UpdateEventClass - Raw response:", res);
        console.log("UpdateEventClass - Response data:", res.data);
        return res.data;
      })
      .then((response) => {
        setLoading(false);
        console.log("UpdateEventClass - Parsed response:", response);
        if (response.api_status === "OK") {
          myToast.notify_success("Class updated successfully");
          setEditingClassId(null);
          setEditingClassName("");
          getEventClasses();
          onRefresh();
        } else {
          console.error("UpdateEventClass - API Error:", response.api_remark);
          myToast.notify_warning(response.api_remark || "Failed to update class");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("UpdateEventClass - Error updating class:", error);
        console.error("UpdateEventClass - Error response:", error.response);
        console.error("UpdateEventClass - Error message:", error.message);
        const errorMsg = error.response?.data?.api_remark || error.message || "Unknown error occurred";
        myToast.notify_error("Error updating class: " + errorMsg);
      });
  }, [event?.event_id, sessionId, editingClassId, editingClassName, getEventClasses, onRefresh]);

  const handleDeleteClass = useCallback((eventClass) => {
    if (!window.confirm(`Are you sure you want to delete the class "${eventClass.class_name}"?`)) {
      return;
    }

    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}DeleteEventClass.php`;

    axios
      .get(URL, {
        params: {
          event_id: event.event_id,
          class_id: eventClass.class_id,
          session_id: sessionId,
          school_code: SCHOOL_CODE,
        },
      })
      .then((res) => {
        console.log("DeleteEventClass response:", res.data);
        return res.data;
      })
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          myToast.notify_success("Class deleted successfully");
          getEventClasses();
          getSchoolClasses();
          onRefresh();
        } else {
          myToast.notify_warning(response.api_remark || "Failed to delete class. Class may have participants.");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error deleting class:", error);
        console.error("Error details:", error.response?.data || error.message);
        myToast.notify_error("Error deleting class: " + (error.response?.data?.api_remark || error.message));
      });
  }, [event?.event_id, sessionId, getEventClasses, getSchoolClasses, onRefresh]);

  if (loading && eventClasses.length === 0) {
    return <MyLoader />;
  }

  return (
    <div>
      {/* Add New Class - Section 1: From Existing School Classes */}
      <div style={{ marginBottom: "24px", padding: "16px", background: "#dcfce7", borderRadius: "10px", border: "2px solid #16a34a" }}>
        <h6 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: 600, color: "#15803d" }}>
          <i className="fa fa-plus-circle" style={{ marginRight: "8px" }} />
          Add from Existing School Classes
        </h6>
        {availableSchoolClasses.length === 0 ? (
          <p style={{ fontSize: "14px", color: "#166534", margin: 0 }}>
            All available school classes have been added to this event.
          </p>
        ) : (
          <div style={{ display: "flex", gap: "10px" }}>
            <select
              value={selectedClassId}
              onChange={(e) => setSelectedClassId(e.target.value)}
              style={{
                flex: 1,
                padding: "10px 14px",
                fontSize: "14px",
                border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                borderRadius: "8px",
                outline: "none",
                background: "#fff",
                cursor: "pointer",
              }}
            >
              <option value="">Select a class...</option>
              {availableSchoolClasses.map((classItem) => (
                <option key={classItem.class_id} value={classItem.class_id}>
                  {classItem.class_name}
                </option>
              ))}
            </select>
            <button
              type="button"
              onClick={handleAddFromExisting}
              disabled={loading || !selectedClassId}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                border: "none",
                background: `linear-gradient(135deg, #16a34a 0%, #15803d 100%)`,
                color: "#fff",
                fontWeight: 600,
                fontSize: "14px",
                cursor: loading || !selectedClassId ? "not-allowed" : "pointer",
                opacity: loading || !selectedClassId ? 0.6 : 1,
              }}
            >
              <i className="fa fa-plus" style={{ marginRight: "6px" }} />
              Add
            </button>
          </div>
        )}
      </div>

      {/* Add New Class - Section 2: New Entry */}
      <div style={{ marginBottom: "24px", padding: "16px", background: "#fef3c7", borderRadius: "10px", border: "2px solid #f59e0b" }}>
        <h6 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: 600, color: "#92400e" }}>
          <i className="fa fa-plus-square" style={{ marginRight: "8px" }} />
          Add New Entry
        </h6>
        <div style={{ display: "flex", gap: "10px" }}>
          <input
            type="text"
            value={newClassName}
            onChange={(e) => setNewClassName(e.target.value)}
            placeholder="Enter new class name"
            style={{
              flex: 1,
              padding: "10px 14px",
              fontSize: "14px",
              border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
              borderRadius: "8px",
              outline: "none",
            }}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleAddNewEntry();
              }
            }}
          />
          <button
            type="button"
            onClick={handleAddNewEntry}
            disabled={loading}
            style={{
              padding: "10px 20px",
              borderRadius: "8px",
              border: "none",
              background: `linear-gradient(135deg, #f59e0b 0%, #d97706 100%)`,
              color: "#fff",
              fontWeight: 600,
              fontSize: "14px",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.6 : 1,
            }}
          >
            <i className="fa fa-plus" style={{ marginRight: "6px" }} />
            Add New
          </button>
        </div>
      </div>

      {/* Classes List */}
      <div>
        <h6 style={{ margin: "0 0 16px 0", fontSize: "16px", fontWeight: 600, color: COLORS.black8 }}>
          Existing Participating Classes
        </h6>
        {eventClasses.length === 0 ? (
          <div style={{ padding: "40px", textAlign: "center", color: "#6b7280" }}>
            <i className="fa fa-users" style={{ fontSize: "48px", marginBottom: "16px", opacity: 0.3 }} />
            <p>No classes found. Add classes to get started.</p>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {eventClasses.map((eventClass, idx) => (
              <div
                key={eventClass.id || eventClass.class_id || `event-class-${idx}`}
                style={{
                  padding: "14px 16px",
                  background: COLORS.white,
                  border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "12px",
                }}
              >
                {editingClassId === eventClass.class_id ? (
                  <>
                    <input
                      type="text"
                      value={editingClassName}
                      onChange={(e) => setEditingClassName(e.target.value)}
                      style={{
                        flex: 1,
                        padding: "8px 12px",
                        fontSize: "14px",
                        border: `2px solid #16a34a`,
                        borderRadius: "6px",
                        outline: "none",
                      }}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          handleUpdateClass();
                        }
                      }}
                    />
                    <button
                      type="button"
                      onClick={handleUpdateClass}
                      disabled={loading}
                      style={{
                        padding: "8px 16px",
                        borderRadius: "6px",
                        border: "none",
                        background: "#16a34a",
                        color: "#fff",
                        fontSize: "13px",
                        cursor: loading ? "not-allowed" : "pointer",
                      }}
                    >
                      <i className="fa fa-check" style={{ marginRight: "4px" }} />
                      Save
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setEditingClassId(null);
                        setEditingClassName("");
                      }}
                      style={{
                        padding: "8px 16px",
                        borderRadius: "6px",
                        border: `2px solid ${COLORS.grey3}`,
                        background: COLORS.white,
                        fontSize: "13px",
                        cursor: "pointer",
                      }}
                    >
                      <i className="fa fa-times" style={{ marginRight: "4px" }} />
                      Cancel
                    </button>
                  </>
                ) : (
                  <>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: "15px", fontWeight: 600, color: COLORS.black8 }}>
                        {eventClass.class_name}
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => handleEditClass(eventClass)}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "6px",
                        border: `2px solid #16a34a`,
                        background: COLORS.white,
                        color: "#16a34a",
                        fontSize: "13px",
                        cursor: "pointer",
                      }}
                    >
                      <i className="fa fa-edit" style={{ marginRight: "4px" }} />
                      Edit
                    </button>
                    <button
                      type="button"
                      onClick={() => handleDeleteClass(eventClass)}
                      disabled={loading}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "6px",
                        border: "none",
                        background: "#ef4444",
                        color: "#fff",
                        fontSize: "13px",
                        cursor: loading ? "not-allowed" : "pointer",
                      }}
                    >
                      <i className="fa fa-trash" />
                    </button>
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
});

ManageClassContent.displayName = 'ManageClassContent';

export default EventList;

